/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'VIDEO SHORTS SAYA',
    see_more: 'LIHAT LEBIH BANYAK',
    no_shorts_found: 'Tidak ada Shorts ditemukan',
    shorts: 'Shorts',
    general_information: 'Informasi Umum',
    gamification: 'Gamifikasi',
    click_to_select_files: 'Klik untuk memilih file',
    selected_files: 'File yang dipilih',
    uploaded: 'Diunggah',
    failed: 'Gagal',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Sistem akan secara otomatis menganalisis dan memilih dokumen yang paling relevan dari perpustakaan organisasi Anda berdasarkan kebutuhan konten.',
    select_from_library: 'Pilih dari perpustakaan',
    search_document: 'Cari dokumen...',
    selected: 'Dipilih',
    loading_documents: 'Memuat dokumen...',
    review_generated_content: 'Tinjau konten yang dihasilkan',
    confirm_and_replace_content: 'Konfirmasi dan ganti konten',
    the_generate_content_will_replace:
      'Konten yang dihasilkan akan menggantikan teks yang ada di halaman yang dipilih. Jika Anda tidak ingin menerapkan perubahan ini, Anda dapat kembali ke langkah sebelumnya.',
    pages_to_be_updated: 'Halaman yang akan diperbarui',
    generated_revisions: 'Revisi yang dihasilkan',
    lesson_preview: 'Pratinjau Pelajaran',
    create_new_folder: 'Buat Folder Baru',
    rename_item: 'Ganti Nama Item',
    enter_folder_name: 'Masukkan nama folder:',
    enter_new_name: 'Masukkan nama baru:',
    folder_name: 'Nama folder:',
    new_name: 'Nama baru',
    move_items: 'Pindahkan Item',
    copy_items: 'Salin Item',
    move_here: 'Pindahkan ke sini',
    copy_here: 'Salin ke sini',
    select_destination_library_and_folder:
      'Pilih perpustakaan dan folder tujuan:',
    items_selected: 'Item yang dipilih',
    version: 'Versi',
    modified_by: 'Diubah oleh',
    size: 'Ukuran',
    restore: 'Pulihkan',
    are_you_sure_you_want_to_restore_this_version:
      'Apakah Anda yakin ingin memulihkan versi ini?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Ini akan menggantikan versi saat ini dengan versi yang dipilih.',
    restore_this_version: 'Pulihkan versi ini',
    restore_not_available: 'Pemulihan tidak tersedia',
    version_history: 'Riwayat Versi:',
    by_making_items_public:
      'Dengan menjadikan item publik, mereka akan terlihat oleh semua orang. Harap tinjau syarat dan ketentuan sebelum melanjutkan.',
    the_selected_items_will_be_copied:
      'Item yang dipilih akan disalin ke perpustakaan publik Anda dan terlihat oleh semua orang.',
    the_selected_items_will_be_copied_to_org:
      'Item yang dipilih akan disalin ke perpustakaan organisasi Anda dan terlihat oleh semua anggota organisasi.',
    the_selected_items_will_be_copied_to_your_private:
      'Item yang dipilih akan disalin ke perpustakaan pribadi Anda dan hanya terlihat oleh Anda.',
    loading_organization: 'Memuat pengguna organisasi...',
    click_download_to_view: 'Klik unduh untuk melihat',
    archive_file: 'File Arsip',
    no_preview_available: 'Pratinjau tidak tersedia',
    audit_report: 'Laporan Audit',
    audit_type: 'Jenis Tindakan',
    i_agree_to_the_terms_and_conditions:
      'Saya setuju dengan syarat dan ketentuan.',
    this_file_is_indexed_for_ai: 'File ini telah diindeks untuk AI.',
    file_is_not_indexed_for_ai: 'File tidak diindeks untuk AI.',
    no_users_found: 'Tidak ada pengguna ditemukan',
    no_users_available: 'Tidak ada pengguna tersedia',
    add_people: 'Tambah orang',
    people: 'Orang',
    access_type: 'Jenis akses',
    no_group_found: 'Tidak ada grup ditemukan',
    add_group: 'Tambah grup',
    groups: 'Grup',
    users_top: 'pengguna',
    confirm_delete: 'Konfirmasi Hapus',
    do_you_want_remove: 'Apakah Anda yakin ingin menghapus',
    form_this_documents_permissions: 'dari izin dokumen ini?',
    no_users_found_in_this_group: 'Tidak ada pengguna dalam grup ini',
    add_selected_users: 'Tambahkan Pengguna Terpilih',
    choose_users_from_the_list: 'Pilih pengguna dari daftar',
    selected_users: 'Pengguna Terpilih',
    archived: 'Diarsipkan',
    request_approval: 'Minta Persetujuan',
    document_in_review: 'Dokumen dalam Tinjauan',
    approve: 'Setujui',
    reject: 'Tolak',
    comment: 'Komentar:',
    enter_your_commit: 'Masukkan komentar Anda...',
    confirm_cancel: 'Konfirmasi Batal',
    upload_3d_zip: 'Unggah 3D Zip',
    delete_items: 'Hapus Item',
    video_upload_request: 'Permintaan Unggah Video',
    reject_video: 'Tolak Video',
    enter_rejection_reason: 'Masukkan alasan penolakan...',
    please_provide_a_reason_for_reejection_this_video:
      'Harap berikan alasan penolakan untuk video ini:',
    generate_trivia_with_ai: 'Hasilkan Trivia dengan AI',
    select_category: 'Pilih Kategori:',
    number_of_question: 'Jumlah Pertanyaan',
    generated_questions: 'Pertanyaan yang Dihasilkan',
    this_will_clear_all_generate_question:
      'Ini akan menghapus semua pertanyaan yang dihasilkan. Lanjutkan?',
    sure_delete: 'Apakah Anda yakin ingin menghapus?',
    delete_this_question: 'Apakah Anda yakin ingin menghapus pertanyaan ini?',
    loading_quiz: 'Memuat Kuis...',
    creteing_file: 'Membuat file',
    opening_desktop_app: 'Membuka aplikasi desktop',
    this_folder_is_empty: 'Folder ini kosong',
    select_a_competition: 'Pilih kompetisi...',
    activity_badges: 'Lencana Aktivitas',
    awarded_every_badges:
      'Diberikan setiap 4, 8, 16, 32, 64, 128, 256, 512 login',
    learning_badges: 'Lencana Pembelajaran',
    awarded_every_courses:
      'Diberikan setiap 1, 4, 8, 16, 32, 64, 128 kursus yang diselesaikan',
    test_badges: 'Lencana Tes',
    awarded_every_passes_tests:
      'Diberikan setiap 2, 4, 8, 16, 32, 64, 128, 256 tes yang lulus',
    assignment_badges: 'Lencana Tugas',
    awarded_every_passed_assignments:
      'Diberikan setiap 1, 2, 4, 8, 16, 32, 64, 128 tugas yang lulus',
    perfectionism_badges: 'Lencana Perfeksionisme',
    awarded_every_assignments_with_scrore:
      'Diberikan setiap 1, 2, 4, 8, 16, 32, 64, 128 tes atau tugas dengan skor 90%+',
    communication_badges: 'Lencana Komunikasi',
    awarded_every_topics_or_comments:
      'Diberikan setiap 2, 4, 8, 16, 32, 64, 128, 256 topik atau komentar',
    certification_badges: 'Lencana Sertifikasi',
    awarded_every_certificates:
      'Diberikan setiap 1, 2, 4, 8, 16, 32, 64, 128 sertifikat',
    level_name: 'Nama Level',
    delete_competition: 'Hapus Kompetisi',
    this_week: 'Minggu Ini',
    this_year: 'Tahun Ini',
    make_organization: 'Jadikan Organisasi',
    no_results_found: 'Tidak ada hasil ditemukan untuk',
    no_items_available: 'Tidak ada item tersedia',
    help_video: 'Video Bantuan',
    select_a_video_from_the_list: 'Pilih video dari daftar untuk mulai belajar'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Jatuhkan file dan pilih lokasi untuk mengunggah.',
    duplicate_lessoon: 'Pelajaran sudah ada di kursus',
    skill_rule_title: 'Silakan Masukkan Judul Skill Journey',
    imageCreatorTitle: 'Pembuat Gambar',
    isTranslated: 'Sudah Diterjemahkan',
    translationCourseDesc:
      'Penerjemahan kursus ini mungkin memerlukan beberapa menit. Terima kasih atas kesabaran Anda!',
    translateCourseTip:
      'Buat kursus terjemahan yang dapat Anda modifikasi secara independen dari versi asli, termasuk semua pelajaran dan halaman.',
    translateModalBtn: 'Terjemahkan',
    translationSuccess: 'Kursus "<0/>" berhasil diterjemahkan!',
    translatingCourse: 'Sedang Menerjemahkan Kursus...',
    translateModalTitle: 'Terjemahkan Kursus',
    translateSelectLang: 'Pilih Bahasa',
    fileDeleteconfirm:
      'Anda yakin ingin menghapus file ini? Tindakan ini tidak dapat dibatalkan.',
    fileDeleteMessage: 'File berhasil dihapus.',
    fileDeleteFailedMessage: 'Gagal menghapus file!',
    fileDelete: 'Hapus file ini.',
    certificate_save_btn: 'Tambahkan Sertifikat ke ',
    maze_path_info: 'Tidak ada jalur yang tersedia untuk grafik!',
    file_size_mb: 'Ukuran file harus kurang dari 25 MB!',
    reports: {
      products: 'Produk',
      users: 'Pengguna',
      ph_username: 'Cari pengguna berdasarkan nama pengguna',
      ph_id: 'Cari pengguna berdasarkan Nomor ID',
      ph_email: 'Cari pengguna berdasarkan email'
    },
    select_upload_section_id: 'File seksi wajib diisi',
    tags_all: 'Semua',
    delete_file_confirm: 'Anda yakin ingin menghapus file ini?',
    delete_file_title: 'Hapus File',
    tooltip_publish: 'Terbitkan kursus pada opsi yang dipilih',
    tooltip_save: 'Simpan kursus dengan pembaruan saat ini',
    tooltip_next: 'Lanjut ke pengaturan kursus berikutnya',
    tooltip_finish: 'Selesaikan dan simpan pembaruan saat ini',
    stories_modal: {
      title_upload: 'Unggah Cerita',
      title_update: 'Perbarui Cerita',
      title_audio: 'File Audio Cerita',
      btn_upload: 'Unggah',
      btn_update: 'Perbarui',
      btn_close: 'Tutup',
      btn_cancel: 'Batal',
      lbl_cover: 'Gambar Sampul Cerita',
      rule_cover: 'Silakan unggah sampul audio cerita!',
      lbl_title: 'Judul Audio Cerita',
      rule_title: 'Silakan masukkan judul audio cerita!',
      lbl_description: 'Deskripsi Audio Cerita',
      rule_description: 'Silakan masukkan deskripsi audio cerita!',
      lbl_file: 'Unggah file audio cerita',
      rule_file: 'Silakan unggah file audio cerita!',
      rule_file_type: 'Silakan unggah file audio cerita yang valid!',
      lbl_select_file: 'Pilih file audio cerita',
      msg_valid_file: 'Silakan pilih file audio cerita yang valid!',
      msg_success: 'File audio cerita berhasil diunggah',
      msg_failed: 'Gagal menetapkan data media!',
      msg_error: 'Kesalahan saat mengunggah file!'
    },
    audio_modal: {
      title_upload: 'Unggah',
      title_update: 'Perbarui',
      title_audio: 'File Audio',
      btn_upload: 'Unggah',
      btn_update: 'Perbarui',
      btn_close: 'Tutup',
      btn_cancel: 'Batal',
      lbl_cover: 'Sampul Audio',
      rule_cover: 'Silakan unggah sampul audio!',
      lbl_title: 'Judul Audio',
      rule_title: 'Silakan masukkan judul audio!',
      lbl_description: 'Deskripsi Audio',
      rule_description: 'Silakan masukkan deskripsi audio!',
      lbl_file: 'Unggah file audio',
      rule_file: 'Silakan unggah file audio!',
      rule_file_type: 'Silakan unggah file audio yang valid!',
      lbl_select_file: 'Pilih file audio',
      msg_valid_file: 'Silakan pilih file audio yang valid!',
      msg_success: 'File audio berhasil diunggah',
      msg_failed: 'Gagal menetapkan data media!',
      msg_error: 'Kesalahan saat mengunggah file!'
    },
    info_episode: 'Gambar sampul untuk episode.',
    btn_delete_episode: 'Hapus episode podcast ini.',
    btn_edit_marketplace: 'Edit Detail Marketplace.',
    btn_save_marketplace: 'Simpan perubahan saat ini.',
    btn_ai_podcast: 'Buat episode podcast bertenaga AI.',
    btn_upload_podcast: 'Unggah episode audio podcast Anda.',
    attach_file:
      'Unggah file untuk berbagi lebih banyak konten dengan audiens Anda.',
    fileDownload: 'Unduh file ini.',
    singleEpishode: 'Episode',
    podcast_music: 'podcast, musik & cerita',
    publishHeader: 'Terbitkan Podcast, Musik & Cerita',
    editHeader: 'Edit Podcast, Musik & Cerita',
    createHeader: 'Buat Podcast, Musik & Cerita',
    marketplaceHeader: 'Detail Marketplace Podcast, Musik & Cerita',
    message_marketplace: 'Silakan lengkapi formulir marketplace!',
    create_podcast_live: 'Podcast & Musik Langsung',
    create_podcast_custom: 'Podcast & Musik Kustom',
    create_podcast_stories: 'Cerita',
    ai_Assisted_podcast_reation: 'Podcast & Musik Dibantu AI',
    publishTitle: 'Terbitkan podcast, musik & cerita untuk tampilan publik.',
    customButton: 'Buat Kustom',
    customTitle: 'Simpan perubahan pada podcast.',
    updateButton: 'Perbarui',
    createButton: 'Buat',
    createNewButton: 'Buat Baru',
    updateTitle: 'Perbarui detail podcast, musik & cerita saat ini.',
    createTitle: 'Buat podcast, musik & cerita baru',
    createNewTitle:
      'Podcast, musik & cerita baru akan dibuat berdasarkan entri saat ini.',
    podcastTitle: 'Daftar Episode',
    podcastStoryTitle: 'Daftar Episode Cerita',
    podcastToolTipTitle: 'Daftar episode podcast',
    uploadAudio: 'Unggah',
    aiAudio: 'Audio AI',
    emptyPodcast: 'Belum ada rekaman podcast, musik & cerita.',
    emptyStoriesPodcast: 'Belum ada cerita ditambahkan.',
    emptyCreatePodcast: 'Silakan buat podcast sebelum menambahkan audio.',
    playPodcast: 'Putar podcast, musik & cerita yang dipilih.',
    pausePodcast: 'Jeda podcast, musik & cerita yang dipilih.',
    selectPodcast: 'Pilih podcast, musik & cerita ini.',
    downloadPodcast: 'Unduh audio ini.',
    uploadAudioFile: 'Unggah audio baru dan ganti audio saat ini.',
    deleteConfirm: 'Anda yakin ingin menghapus audio ini?',
    roomName: 'Nama Podcast',
    addGuestTitle: 'TAMBAH PEMBICARA TAMU',
    showTime: 'Waktu Tayang',
    startTime: 'Waktu Mulai',
    endTime: 'Waktu Selesai',
    erorMsgImg: 'Silakan pilih gambar yang valid.',
    failedMsgImg: 'Gagal memuat gambar. Coba lagi!',
    failedMsgUpload: 'Gagal mengunggah gambar sampul!',
    btnCoverUpload: 'Unggah Sampul',
    is_private: 'Pribadi',
    to_attach: 'Lampirkan File',
    file_attached: 'File Terlampir',
    main_event: 'Acara Utama',
    event: 'Acara',
    upload_pdf: 'Unggah PDF',
    portrait: 'Potret',
    landscape: 'Lanskap',
    import_from_library: 'Impor Teks dari Perpustakaan Media',
    question_answer_ai: 'AI Pertanyaan/Jawaban',
    take_maze: 'Ikuti MetaMaze',
    training: 'Pelatihan',
    select_transcribe_locale: 'Pilih Bahasa untuk Transkripsi',
    transcribe_limit: 'Silakan Input Menit Transkripsi',
    not_complete: 'Info Marketplace Belum Lengkap',
    complete: 'Info Marketplace Sudah Lengkap',
    not_admin: 'Butuh hak admin untuk menerbitkan ke Marketplace',
    no_course:
      'Silakan masukkan judul dan pilih gambar untuk aktifkan Marketplace',
    scorm_not_complete:
      'Silakan masukkan judul dan pilih gambar untuk unggah file SCORM',
    not_found_maze: 'MetaMaze Tidak Ditemukan',
    email_require: 'Email Wajib diisi',
    poll_required: 'Data Polling Diperlukan',
    alert: 'Peringatan!',
    warning: 'Perhatian!',
    ok: 'Ok',
    cancel: 'Batal',
    done: 'Selesai',
    insert: 'Sisipkan',
    private: 'Pribadi',
    public: 'Publik',
    no_connection: 'Koneksi Internet Terputus',
    switch: 'Ganti',
    share_screen: 'Bagikan Layar',
    stop_share_screen: 'Berhenti Bagikan Layar',
    share_screen_with_camera: 'Bagikan Layar & Kamera',
    stop_share_screen_with_camera: 'Berhenti Bagikan Layar & Kamera',
    camera_on: 'Kamera Aktif',
    camera_off: 'Kamera Mati',
    mic_on: 'Unmute',
    mic_off: 'Mute',
    fullscreen: 'Layar Penuh',
    live_now: 'Siaga',
    schedule_on: 'Jadwalkan untuk',
    organisations: 'Organisasi',
    org_groups: 'Grup Organisasi',
    specific_user: 'Pengguna Tertentu',
    gif: 'GIF',
    unavailable: 'Tidak Tersedia',
    yes: 'Ya',
    no: 'Tidak',
    event_duration_message: 'Maksimal 300 menit (5 jam)',
    send_email: 'Kirim Notifikasi Email',
    admin_only: 'Hanya Admin',
    join: 'Bergabung',
    leave: 'Keluar',
    share: 'Bagikan',
    share_text:
      'Silakan masukkan alamat email orang yang ingin Anda bagikan file ini.',
    share_text_title: 'Bagikan PDF',
    share_text_title_txt: 'Bagikan Teks',
    select_users: 'Pilih Pengguna',
    delete: 'Hapus',
    attachment_event: 'Lampiran untuk acara:',
    transcribe_limit: 'Menit Transkripsi',
    monthly_transcribe: 'Batas Transkripsi Bulanan:',
    enable_ai: 'Aktifkan AI:',
    enable_maze: 'Aktifkan MetaMaze:',
    media_service: 'Layanan Media',
    allow_others: 'Izinkan Orang Lain Mengedit',
    join_breakout_room: 'Gabung Breakout Room',
    bio: 'Bio',
    linkedin: 'LinkedIn',
    select_org_report:
      'Silakan temukan dan pilih organisasi untuk membuat laporan.',
    org_image_not_found: 'Gambar Tidak Ditemukan',
    insert_text: 'Sisipkan Teks',
    insert_question_answer: 'AI Pertanyaan/Jawaban',
    modal_title2: 'Galeri Teks',
    my_text_library: 'Perpustakaan Teks Saya',
    ai: 'AI',
    public_text_library: 'Perpustakaan Teks Publik',
    organization_text_library: 'Perpustakaan Teks Organisasi',
    no_transcribed_text: 'Tidak Ada Teks yang Ditranskripsi',
    public_text_not_found: 'Teks Publik Tidak Ditemukan',
    org_text_not_found: 'Teks Organisasi Tidak Ditemukan',
    org_video_not_found: 'Video Tidak Ditemukan',
    canva: 'Kerjakan dari Canva',
    canva_open: 'Klik di sini untuk membuka editor Canva.',
    pdf: 'PDF',
    txt: 'TEKS',
    human: 'Premium',
    shared_file: 'File Anda berhasil dibagikan.',
    error_shared_file: 'Terjadi masalah saat berbagi file. Silakan coba lagi.',
    publish: 'Terbitkan',
    maze_scenes: 'Adegan MetaMaze',
    pexel_images: 'Gambar Pexel',
    group: 'Grup',
    group_name: 'Nama Grup',
    select_group: 'Pilih Grup',
    search_maze: 'Cari MetaMaze',
    hosts: 'Pembawa Acara',
    avg_score: 'Persentase Skor',
    maze_report: 'Laporan Maze',
    maze_view: 'Tampilan Maze',
    title_maze: 'MetaMaze',
    author: 'Penulis',
    match: 'Kecocokan Jalur',
    preview_mazeTitle: 'Judul: ',
    other: 'Lainnya',
    total: 'TOTAL',
    report_course: 'KURSUS',
    report_courses: 'KURSUS',
    report_event: 'ACARA',
    report_events: 'ACARA',
    report_maze: 'MAZE',
    report_personalize_learning: 'PEMBELAJARAN PERSONAL',
    report_live_assessment: 'PENILAIAN LANGSUNG',
    report_live_assessments: 'PENILAIAN LANGSUNG',
    report_skill_journey: 'PERJALANAN KETERAMPILAN',
    skill_journey: 'Perjalanan Keterampilan',
    skill_journeys: 'Perjalanan Keterampilan',
    date: 'TANGGAL: ',
    search_people: 'Cari Orang',
    passed: 'LULUS',
    failed: 'TIDAK LULUS',
    item: 'ITEM',
    type: 'TIPE',
    minimum_pass_score: 'SKOR MINIMUM UNTUK LULUS',
    resources_count: 'JUMLAH SUMBER DAYA',
    back: 'KEMBALI',
    resources: 'SUMBER DAYA',
    time_spent: 'WAKTU YANG DIGUNAKAN (MENIT)',
    detail: 'DETAIL',
    watched_time_mins: 'WAKTU TONTON (MENIT)',
    personalize_learning: 'Pembelajaran Personal',
    result: 'Hasil',
    assessment_title: 'Judul',
    marketPlace_graph: 'Grafik Marketplace',
    attachments: 'Lampiran Tambahan',

    new_scorm_course: 'Unggah Kursus SCORM Baru',
    upload_scorm_course: 'Unggah Kursus SCORM',
    new_maze: 'Buat MetaMaze Baru',
    new_skill_journey: 'Buat Perjalanan Keterampilan',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Perjalanan Keterampilan',
    new_discussion_room: 'Buat Podcast Baru',

    title: 'Apa yang ingin Anda lakukan hari ini?',
    build_course: 'Bangun Kursus Saya',
    live_broadcast: 'Siaran Langsung',
    invite_users: 'Undang Pengguna ke Organisasi Saya',
    build_voice_over: 'Bangun Voiceover Saya',
    view_reports: 'Lihat Laporan',
    upload_media: 'Unggah Media atau Karya Saya dan Bagikan',
    main_menu: 'Menu Utama',
    get_started: 'MULAI',
    search_group: 'Cari Grup Organisasi',
    ai_course: 'Kursus AI',
    search_user: 'Cari Nama Perusahaan',
    no_maze: 'Saat ini belum ada MetaMaze.',
    conference_event_title: 'Acara Konferensi',
    conference_event_subTitle: 'Acara Konferensi yang Selesai',
    conference_event: 'Saat ini belum ada acara konferensi.',
    no_skill: 'Saat ini belum ada perjalanan keterampilan.',
    no_podcast: 'Saat ini belum ada podcast.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Penilaian Langsung Sebelumnya',
    no_live_assessment: 'Saat ini belum ada penilaian langsung.',
    enrolled_courses: 'Kursus',
    my_video_channel: 'Saluran Video Saya',
    enrolled_liveEvents: 'Acara Langsung',
    sharebot: 'Sharebot',
    selected_language: 'Bahasa yang Dipilih',
    shareSphere_game: 'Permainan ShareSphere',
    maze: 'MetaMaze',
    skill: 'Perjalanan Keterampilan',
    channel: 'Saluran',
    order: 'Pesanan',
    is_record: 'Rekaman',
    no_maze_found: 'Tidak ada MetaMaze yang ditemukan.',
    maze_self_limit_reached: 'Batas penilaian mandiri MetaMaze telah tercapai.',
    metamaze_two_times: 'Anda telah mengikuti MetaMaze ini sebanyak 2 kali.',
    metamaze_two_times_no_result:
      'Anda telah mengikuti MetaMaze ini sebanyak 2 kali. Hasil Anda tidak akan dicatat setelah penilaian mandiri yang ketiga.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Skor Minimum untuk Lulus',
    organization: 'Silakan Pilih Organisasi',
    pass_score_mark: 'Silakan Masukkan Nilai Antara 1 hingga 100',
    maze_cloning_success: 'MetaMaze "<0/>" berhasil dikloning!',
    create_certificate: 'Buat Sertifikat',
    create_badge: 'Buat Lencana',
    certificate_added: 'Sertifikat Ditambahkan.',
    badge_added: 'Lencana Ditambahkan.',
    certificate_warning:
      'Anda tidak dapat mengedit sertifikat/lencana setelah diterbitkan!',
    created_course_plan:
      'Edit dan terbitkan kursus yang Anda buat serta rencanakan acara langsung',
    market_place_space: 'Marketplace',
    select_course_language: 'Pilih bahasa (Opsional)',
    select_language: 'Pilih bahasa',
    file_upload: 'Unggah file',
    text: 'Tulis teks di sini…',
    attempts_count: 'Jumlah Percobaan Ulang yang Diizinkan untuk Pengguna',
    no_of_people_placeholder: 'Jumlah Orang',

    back_to_maze: 'Kembali ke Skenario MetaMaze',
    edit_maze: 'Edit Maze',
    wait: 'Tunggu...',
    retry: 'Coba Lagi',
    publish_scorm_course: 'Terbitkan Kursus SCORM Anda',
    publish_maze: 'Terbitkan MetaMaze Anda',
    import: 'Impor Elemen',

    answer_correct: 'Pilih Jawaban yang Benar',
    author_name: 'Silakan Masukkan Nama Penulis',
    select_category: 'Silakan Pilih Kategori',
    course_outline: 'Silakan Masukkan Garis Besar Kursus',
    course_obj: 'Silakan Masukkan Tujuan Kursus',
    course_description: 'Silakan Masukkan Deskripsi Kursus',
    maze_outline: 'Silakan Masukkan Garis Besar Maze',
    maze_obj: 'Silakan Masukkan Tujuan Maze',
    maze_description: 'Silakan Masukkan Deskripsi Maze',
    lessons: 'Silakan Masukkan Jumlah Pelajaran',
    user_email_require: 'Email Pengguna Diperlukan',
    team_size: 'Ukuran Tim Diperlukan',
    enter_price: 'Silakan Masukkan Harga (5 atau Lebih)',
    input_title_maze: 'Silakan Masukkan Judul Maze',
    trainer_bio: 'Silakan Masukkan Biografi Pelatih',
    trainer_linkedin: 'Silakan Masukkan LinkedIn Pelatih',
    error_video: 'Silakan Masukkan Jumlah Video',
    input_video_link: 'Silakan Masukkan Tautan Video',
    number_of_video: 'jumlah video',
    number_of_lessions: 'jumlah pelajaran',

    no_of_people_in_conference: 'Berapa orang dalam konferensi?',
    transcribe_settings: 'Pengaturan Transkripsi',
    transcribe: 'Transkripsi',
    cloning_maze: 'Mengkloning MetaMaze...',
    id_number: 'Nomor ID',
    timezone: 'Zona Waktu',
    edit_maze: 'Edit',
    delete_maze: 'Hapus',
    view_maze: 'Lihat',
    create_metamaze: 'Buat MetaMaze',
    metamaze_scenario: 'Skenario MetaMaze',
    publish_metamaze: 'Pengaturan publikasi',
    search_result: 'Hasil Pencarian:',
    search_for: 'Cari',
    search_no_result: '- Tidak ada hasil yang tersedia!',
    channel_no_available: 'Tidak ada saluran yang tersedia!',
    this_card: 'Ini adalah kartu',
    course_no_available: 'Tidak ada kursus yang tersedia!',
    exit_fullscreen: 'Keluar dari Layar Penuh',
    bg_image: 'Gambar Latar Belakang',
    introduction: 'Pendahuluan',
    summary: 'Ringkasan',
    generate_introduction: 'Buat Pendahuluan',
    generate_summary: 'Buat Ringkasan',
    bullet_points: 'Poin-poin',
    title_simulation: 'Silakan Masukkan Nama Simulasi',
    view_generated_images: 'Lihat Gambar yang Dihasilkan',
    image_transparency: 'Transparansi Gambar',
    template_bg_color: 'Warna Latar Template',
    select_template_layout: 'Pilih Tata Letak Template',
    reload_template: '(Muat ulang template)',
    are_you_sure_want_close: 'Apakah Anda yakin ingin menutup?',
    all_your_changes_will_be_lost: 'Semua perubahan Anda akan hilang.',
    please_checked_before_generated_video:
      'Silakan pastikan semua kondisi dicentang sebelum membuat video.',
    voice_must_be_selected: 'Suara harus dipilih',
    avatar_must_be_selected: 'Gambar avatar harus dipilih.',
    maximum_five_slides_try_again:
      'Kesalahan saat mengekstrak gambar dari file Anda. Pastikan file memiliki maksimal 5 slide dan ada catatan di setiap slide. Silakan coba lagi!',
    back_to_upload: 'Kembali ke Unggahan',
    uploading_file_to_server: 'Mengunggah file Anda ke server',
    extracting_images_from_your_file: 'Mengekstrak gambar dari file Anda',
    upload_your_ppt_or_drag:
      'Unggah file presentasi Anda (.PPTX) atau seret ke sini.',
    maximum_five_slides_error:
      'Pastikan file PowerPoint Anda berisi maksimal 5 slide dan ada catatan di setiap slide. Jika tidak, akan terjadi kesalahan.',
    number_of_questions_generated: 'Jumlah Pertanyaan yang Akan Dihasilkan',
    quiz_page_this_cannot_be_done:
      'Apakah Anda yakin ingin menambahkan kuis ke halaman ini? Ini tidak dapat dibatalkan.',
    confirm_selection: 'Konfirmasi Pilihan',
    select_quiz_page: 'Pilih Halaman Kuis',
    lesson_do_you_want_add_this_quiz:
      'Bagian pelajaran mana yang ingin Anda tambahkan kuis ini?',
    beginning_of_lesson: 'Di Awal Pelajaran',
    end_of_lesson: 'Akhir Pelajaran',
    currently_active_page: 'Halaman Saat Ini Aktif',
    finish: 'Selesai',
    upload_selection_file: 'Unggah File Bagian',
    general_quiz: 'Kuis Umum',
    manage_sequence: 'Kelola Urutan',
    save_sequence: 'Simpan Urutan',
    new: 'Baru',
    in_progress: 'Sedang Berlangsung',
    recommended_course: 'Kursus yang Direkomendasikan',
    up_coming: 'Akan Datang',
    past_live: 'Live Sebelumnya',
    input_your_channel_name: 'Silakan masukkan nama Saluran Anda!',
    organization_place: 'Marketplace Organisasi',
    marketplace_report: 'Laporan Marketplace',
    story_writing: 'Penulisan Cerita',
    Ai_quiz: 'Kuis AI',
    generate_quiz: 'Buat Kuis',
    create_story: 'Buat Cerita',
    change_layout_page: 'Anda akan mengubah tata letak halaman ini.',
    change_layout_message:
      'Harap dicatat bahwa hanya teks, gambar, latar belakang, dan logo yang akan disimpan. Semua elemen lainnya akan dihapus dari halaman.',
    reviews: 'Ulasan',
    tab_attachments: 'Lampiran',
    zoom_in: 'Perbesar',
    zoom_out: 'Perkecil',
    zoom_reset: 'Atur Ulang Zoom',
    no_attachment: 'Tidak ada lampiran.',
    select_upload_simulation: 'Silakan pilih/unggah simulasi.',
    quiz_updated_successfully: 'Kuis berhasil diperbarui!',
    quizes: 'Kuis',
    trivia: 'Trivia',
    closing: 'Menutup...',
    products: 'Produk',
    ask_questions: 'Ajukan pertanyaan di sini...',
    course_information: 'Informasi Kursus',
    course_assistance: 'Bantuan Pembuat Kursus',
    go_back: 'Kembali',
    ai_generate_content_progress: 'Proses Pembuatan Konten dengan AI',
    view_generate_content: 'Lihat Konten yang Dihasilkan',
    generate_error: 'Kesalahan Saat Pembuatan!',
    confirm_creating_course:
      'Apakah Anda ingin mengonfirmasi pembuatan kursus menggunakan konten ini?',
    generate_content_automatically:
      'Ini akan menambahkan semua konten yang dihasilkan sebagai pelajaran dan halaman ke kursus Anda secara otomatis.',
    quiz_created_successfully: 'Kuis berhasil dibuat!',
    create_quiz: 'Buat Kuis',
    quiz_setting: 'Pengaturan Kuis',
    please_fill_quiz_setting: '* Harap isi semua bidang dalam Pengaturan Kuis',
    question_list: 'Daftar Pertanyaan',
    add_quiz_to_page: 'Tambahkan Kuis ke Halaman',
    form_create_question: 'Formulir Membuat Pertanyaan',
    user_information_updated: 'Informasi Pengguna Berhasil Diperbarui!',
    your_stripe_activete_to_continue:
      'Akun Stripe Anda tidak aktif. Silakan sambungkan atau aktifkan untuk melanjutkan.',
    connect_tripe: 'Sambungkan Stripe',
    certificate_sent_sucessfully: 'Sertifikat berhasil dikirim ke email Anda.',
    error_try_again: 'Terjadi Kesalahan. Coba Lagi!',
    error_delete_channel: 'Kesalahan saat menghapus saluran.',
    error_update_sub: 'Kesalahan saat memperbarui langganan.',
    end_time_cannot_start: 'Waktu berakhir tidak boleh sebelum waktu mulai.',
    start_date_time_interval: 'Tanggal dan Interval Waktu Mulai Diperlukan!',
    podcast_updated_successful: 'Podcast berhasil diperbarui.',
    podcast_created_successful: 'Podcast berhasil dibuat.',
    podcast_published_successful: 'Podcast berhasil dipublikasikan',
    podcast_cover_updated: 'Sampul podcast diperbarui',
    new_podcast_details:
      'Podcast baru akan dibuat dari podcast saat ini dengan detail masukan baru.',
    current_update_podcast: 'Perbarui podcast saat ini, musik & detail cerita.',
    create_new_podcast: 'Buat podcast baru',
    publish_podcast_public_view: 'Terbitkan podcast untuk dilihat publik.',
    only_allowed_twenty_five_email: 'Hanya diizinkan 25 email',
    only_allowed_five_email: 'Hanya diizinkan 5 email.',
    cover_is_required: 'Sampul Diperlukan.',
    topic_is_required: 'Topik Diperlukan.',
    delete_schedule: 'Hapus Jadwal',
    make_as_coaching: 'Tandai sebagai Ketersediaan Pelatihan',
    manage_category: 'Kelola Kategori',
    threshold: 'Ambang Batas',
    threshold_popup:
      'Nilai ambang batas dalam persentase (%), nilai setelah rekomendasi diaktifkan untuk kategori tertentu.',
    list_of_catagory: 'Daftar Kategori',
    category_name: 'Nama Kategori',
    category_threshold: 'Ambang Batas Kategori',
    play_game: 'Mainkan Game',
    switching_organization: 'Beralih Organisasi...',
    coaching_session: 'Sesi Pelatihan',
    required_channel_id: 'ID Saluran wajib diisi!',
    error_occured_try_again: 'Terjadi kesalahan. Coba lagi!',
    please_complete_marketplace_form: 'Silakan lengkapi formulir marketplace!',
    upload_file_corrupt: 'File yang diunggah rusak.',
    course_not_published: 'Kursus belum dipublikasikan!',
    error_request: 'Kesalahan pada permintaan. Silakan coba lagi!',
    skill_request: 'Silakan lengkapi kolom yang belum diisi!',
    show_time: 'Tampilkan Waktu',
    start_time: 'Waktu Mulai',
    end_time: 'Waktu Selesai',
    room_name: 'Nama Podcast',
    add_guest_speaker: 'Tambahkan Pembicara Tamu',
    cover_picture: 'Gambar Sampul',
    guest_speaker: 'Pembicara Tamu',
    see_more: 'Lihat Lebih Banyak',
    see_less: 'Lihat Sedikit',
    background: 'Latar Belakang',
    icon: 'Ikon',
    icon_size: 'Ukuran Ikon',
    icon_color: 'Warna Ikon',
    only_text: 'Teks Saja',
    change_bg: 'Ganti warna latar',
    bg_color: 'Warna Latar',
    font_size: 'Ukuran Font',
    normal: 'Normal',
    change_color: 'Ganti warna teks',
    slant_text: 'Teks Miring',
    text_radius: 'Radius Teks',
    vertical_align: 'Rata Vertikal',
    horizontal_align: 'Rata Horisontal',
    change_icon_color: 'Ganti warna ikon',
    upload_icon: 'Unggah Ikon',
    upload_signature: 'Unggah Tanda Tangan',
    add_another_sign: 'Tambahkan tanda tangan lain',
    name_badges: 'Nama Lencana',
    should_less_150: 'harus ≤ 150 karakter',
    your_badge: 'Lencana Anda',
    do_you_want_delete_badge: 'Yakin ingin menghapus lencana ini?',
    do_you_want_delete_cert: 'Yakin ingin menghapus sertifikat ini?',
    upload_logo: 'Unggah Logo',
    name_of_cert: 'Nama Sertifikat',
    upload_cert: 'Perbarui Sertifikat',
    your_cert: 'Sertifikat Anda',
    translate_to: 'Terjemahkan ke',
    select_file_attach: 'Pilih File untuk Dilampirkan',
    certificate: 'Sertifikat',
    badge: 'Lencana',
    publish_options: 'Opsi Publikasi',
    publish_skills_journey: 'Publikasikan Skill Journey',
    videos: 'Video',
    generate_ai_video:
      'Proses pembuatan video mungkin memakan waktu. Anda akan diberi tahu melalui email setelah selesai.',
    trainer_information: 'Informasi Pelatih',
    promotional_video_link: 'Tautan Video Promosi',
    please_select: 'Silakan pilih',
    image_name: 'Nama gambar:',
    image_size: 'Ukuran gambar:',
    charecters_fifteen_less: '≤ 15 karakter',
    leadership: 'Kepemimpinan',
    text_arc: 'Lengkung Teks',
    vertical: 'Vertikal',
    horizontal: 'Horisontal',
    badge_history: 'Riwayat Lencana',
    templates: 'Template',
    sign: 'Tanda Tangan',
    logo: 'Logo',
    certificate_history: 'Riwayat Sertifikat',
    please_wait: 'Mohon Tunggu...',
    information: 'Informasi',
    support_five_thousand_live_event:
      'Mendukung hingga 5000 peserta untuk acara langsung',
    support_ten_live_event: 'Mendukung hingga 10 peserta video langsung',
    we_will_back_participant:
      'Kami akan kembali dengan acara yang dihadiri oleh banyak peserta.',
    course_objectives: 'Tujuan Kursus',
    course_outlines: 'Kerangka Kursus',

    price_dollor: 'harga (USD)',
    not_completed: 'Belum Selesai',
    enable_marketplace: 'Aktifkan Marketplace',
    enable_course_ai: 'Aktifkan Pembuatan Kursus dengan AI',
    enable_report_to_admin: 'Aktifkan Tampilan Laporan untuk Admin',
    enable_white_label: 'Aktifkan White Label',
    enable_eleven_labs_for_maze_play: 'Aktifkan Elevenlabs untuk Maze Play',
    enable_eleven_labs_for_maze_play_cloned:
      'Aktifkan Elevenlabs untuk Suara Kloning Maze Play',
    not_completed: 'Belum Selesai',
    simulation_quiz: 'Kuis Simulasi',
    bg_color_setting: 'Pengaturan Warna Latar',
    color_preview: 'Pratinjau Warna',
    choose_new_color: 'Pilih Warna Baru',
    remove_color: 'Hapus Warna',
    apply_color: 'Terapkan Warna',
    elemeent_in_a_sceenario_page:
      'Anda tidak dapat menambahkan elemen lain di halaman skenario. Silakan coba halaman lain atau hapus skenario dari halaman terlebih dahulu.',
    no_data_found: 'Tidak Ada Data.',
    references: 'Referensi',
    open_file: 'Buka File',
    showing_result: 'Menampilkan Hasil:',
    fiften_day_free_trail: 'Uji Coba Gratis 15 Hari',
    your_browser_does_not_support:
      'Peramban Anda tidak mendukung elemen audio.',
    podcast_desc: 'Deskripsi Podcast',
    input_podcast_desc: 'Silakan Masukkan Deskripsi Podcast',
    podcast_obj: 'Tujuan Podcast',
    input_podcast_obj: 'Silakan Masukkan Tujuan Podcast',
    podcast_outline: 'Garis Besar Podcast',
    input_podcast_outline: 'Silakan Masukkan Garis Besar Podcast',
    add_file: 'Tambahkan File',
    generate_podcast_audio: 'Buat Audio Podcast',
    generate_uploaded_file_input_parameter:
      'Menghasilkan konten berdasarkan file yang diunggah dengan parameter yang diberikan.',
    go_backe_generation_state: 'Kembali ke tahap generasi konten.',
    create_ai_powered_podcast:
      'Buat episode podcast bertenaga AI dengan audio yang digenerasi.',
    generate_voice_for_all_podcast:
      'Silakan buat suara untuk semua episode podcast.',
    create_podcast_episode: 'Buat Episode Podcast',
    voice_name: 'Nama Suara',
    input_custom_name: 'Silakan masukkan nama kustom!',
    enter_custom_name: 'Masukkan nama suara kustom',
    upload_complete: 'Unggahan selesai',
    uploading_in_progress: 'Unggahan sedang berlangsung...',
    podcast_stream_content: 'Aliran Konten Podcast',
    upload_podcast_cover: 'Silakan unggah sampul podcast!',
    enter_podcast_name: 'Silakan masukkan nama podcast!',
    podcast_topic: 'Topik Podcast',
    enter_podcast_topic: 'Silakan masukkan topik podcast!',
    enter_podcast_desc: 'Silakan masukkan deskripsi podcast!',
    number_of_speaker: 'Jumlah Pembicara',
    select_the_number_of_speaker: 'Silakan pilih jumlah pembicara!',
    number_of_episode: 'Jumlah Episode',
    input_number_of_episode: 'Silakan masukkan jumlah episode!',
    podcast_length: 'Durasi Podcast',
    select_the_podcast_length: 'Silakan pilih durasi podcast!',
    short_podcast: 'Pendek (5–10 menit)',
    medium_podcast: 'Sedang (15–18 menit)',
    long_podcast: 'Panjang (18+ menit)',
    name_of_host: 'Nama Host',
    enter_host_name: 'Silakan masukkan nama host!',
    guest_name: 'Nama Tamu',
    enter_guest_name: 'Silakan masukkan nama tamu!',
    choose_speaker_tone: 'Pilih nada suara pembicara',
    enter_speaker_tone: 'Silakan pilih nada suara podcast!',
    informal: 'Santai',
    formal: 'Resmi',
    serious: 'Serius',
    light_humor: 'Humor Ringan',
    casual: 'Kasual',
    select_content_source: 'Pilih Sumber Konten',
    from_internet: 'Dari Internet',
    upload_pdf_internet: 'Unggah PDF atau Dokumen Internal',
    note: 'Catatan:',
    podcast_content_will_be_automatically_generated:
      'Konten podcast akan digenerasi secara otomatis menggunakan sumber tepercaya.',
    upload_or_select_file: 'Silakan unggah atau pilih file!',
    podcast_eposode_title: 'Judul Episode Podcast',
    enter_podcast_title: 'Silakan masukkan judul episode!',
    podcast_episode_des: 'Deskripsi Episode Podcast',
    enter_podcast_episode_des: 'Silakan masukkan deskripsi episode!',
    voice: 'Suara',
    music: 'Musik',
    select_music: 'Pilih musik',
    play_the_music: 'Putar musik',
    stop_the_music: 'Hentikan musik',
    context: 'Konteks',
    generate_audio_content_selected_voice:
      'Ini akan menghasilkan audio konten sesuai suara terpilih.',
    required_field_before_submitting:
      'Silakan isi semua kolom yang diperlukan sebelum mengirim.',
    regenerate_voice: 'Hasilkan Ulang Suara',
    generate_voice: 'Hasilkan Suara',
    your_browser_does_not_suppot: 'Peramban Anda tidak mendukung elemen audio.',
    are_sure_leave_podcast: 'Yakin ingin meninggalkan podcast?',
    broadcast_ongoing:
      'Siaran sedang berlangsung. Apakah Anda yakin ingin meninggalkan halaman ini?',
    brodcaster_unavailable: 'Broadcaster saat ini tidak tersedia.',
    setting_calender_for_booking: 'Mengatur Kalender untuk Pemesanan',
    add_calender: 'Tambahkan Kalender',
    waiting_join_host: 'Menunggu host bergabung...',
    no_reviews_found: 'Tidak Ada Ulasan.',
    rated_already: 'Anda sudah memberi penilaian pada acara langsung ini.',
    downlink_png: 'unduh_png',
    downlink_jpg: 'unduh_jpg',
    donwload_file_format: 'Silakan pilih format file yang ingin Anda unduh.',
    crashed_event:
      'Acara ini gagal. Anda perlu membuat acara baru. Maaf atas ketidaknyamanannya.',
    prompt: 'Prompt:',
    generated_image: '🚀 Menghasilkan gambar... Mohon tunggu.',
    download_add: 'Unduh semua',
    setting_generator: 'Pengatur Generator',
    enter_image_prompt: 'Silakan masukkan prompt gambar',
    image_prompt: 'Masukkan prompt gambar',
    negative_prompt: 'Prompt Negatif',
    negative_image_prompt: 'Masukkan prompt negatif untuk gambar',
    number_output: 'Jumlah Output',
    enter_number_output: 'Silakan masukkan jumlah output',
    image_style: 'Silakan pilih gaya gambar',
    output_format: 'Format Output',
    seeds: 'Seed',
    enter_seeds: 'Silakan masukkan jumlah seed',
    performance_mode: 'Mode Performa',
    quality: 'Kualitas',
    speed: 'Kecepatan',
    balanced: 'Seimbang',
    guidance_scale: 'Skala Panduan',
    enter_guidance: 'Silakan masukkan skala panduan',
    select_image: 'Silakan pilih gambar.',
    image_prmt: 'Prompt Gambar',
    generate_image_list_empty: 'Daftar gambar yang dihasilkan kosong.',
    knowledge_center_tooltrip_des:
      'Dapatkan jawaban ringkas dan akurat untuk berbagai pertanyaan, termasuk pengetahuan umum, dari sumber Internet melalui model AI.',
    contexts: 'Konteks',
    ai_processing_video_sharebot:
      'Pemrosesan video AI akan memakan waktu sekitar 24 jam dan tercermin di Sharebot.',
    remove_sharebot_video:
      'Untuk menghapus referensi video ke Sharebot, silakan hapus transkrip beserta video.',
    remove_sharebot_video_audio:
      'Menghapus transkrip akan menghilangkan referensi audio/video Sharebot, namun video tetap muncul di media.',
    monthly_live_stream:
      'Untuk mengubah batas streaming langsung bulanan silakan hubungi',
    monthly_transcribe_limit:
      'Untuk mengubah batas transkripsi bulanan silakan hubungi',
    must_be_one_to_three_hundred: 'Harus antara 1 hingga 300 menit.',
    all_field_required: 'Semua bidang wajib diisi.',
    duration_minute: 'Durasi (maksimal 300 menit)',
    gender: 'Jenis Kelamin',
    select_gender: 'Pilih Jenis Kelamin',
    accent: 'Aksen',
    select_accent: 'Pilih Aksen',
    create_voice: 'Buat Suara',
    enter_voice_name: 'Masukkan Nama Suara',
    select_voice_gender: 'Silakan pilih jenis suara',
    upload_voice: 'Unggah Suara Anda',
    upload_voice_mp_three: 'Unggah suara Anda (.mp3)',
    cloned_voice: 'Suara Terkopi',
    voice_type: 'Jenis Suara',
    select_voice_type: 'Pilih Jenis Suara',
    sharelook_stand: 'Standar',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Kustom (Kloning Suara)',
    create_auto_flow: 'Buat Alur Otomatis',
    how_many_layers: 'Berapa lapisan?',
    verify_selection: 'Verifikasi Pilihan',
    uploaded_successful: 'Berhasil diunggah',
    upload_failed: 'Unggahan gagal',
    upload_only_five_mb: 'Unggah Konten (PDF maksimal 5 MB)',
    docs_from_org_library: 'Gunakan Dokumen dari Perpustakaan Organisasi',
    failed_maze_generate: 'Gagal membuat maze. Silakan coba lagi.',
    generate_metamaze: 'Membuat MetaMaze...',
    metamaze_being_generated:
      'MetaMaze Anda sedang dibuat. Anda akan diberitahu via email setelah selesai.',
    metamaze_generate_successfully: 'MetaMaze berhasil dibuat!',
    metamaze_with_proceed: 'Anda sekarang dapat melanjutkan ke MetaMaze.',
    ai_metamaze_generate: 'Pembuatan MetaMaze dengan AI',
    what_kind_maze_create: 'Jenis maze apa yang ingin Anda buat?',
    manual_metamaze_creation: 'Pembuatan MetaMaze Manual',
    manually_maze_customizing_scnario:
      'Buat MetaMaze manual dengan menyesuaikan skenario dan pohon opsi',
    maze_ai_generated: 'Secara otomatis membuat maze dengan AI',
    unmark_deadend: 'Batalkan penandaan dead‑end',
    mark_deadend: 'Tandai sebagai dead‑end',
    select_multiple_image_for_scenario:
      'Anda dapat memilih beberapa gambar untuk skenario.',
    select_your_image: 'Gambar pilihan Anda',
    click_to_preview: 'Klik untuk melihat pratinjau',
    are_you_sure_delete_image: 'Yakin ingin menghapus gambar ini?',
    select_image_from_library: 'Pilih Gambar dari Perpustakaan Media',
    uploading_video: 'Mengunggah video...',
    tree_node_type: 'Jenis Node Pohon',
    correct_option_scenario: 'Opsi atau Skenario Benar',
    incorrect_option: 'Opsi Salah',
    option_scenario_without_text: 'Opsi atau skenario tanpa teks',

    dead_end: 'Dead End (Batas Merah)',
    correct_path: 'Jalur Benar',
    incorrect_path_not_selected_correct_option_path:
      'Jalur Salah / Opsi benar tidak dipilih',
    double_click_on_tree_node:
      'Saat Anda mengklik dua kali pada node pohon, editor teks akan secara otomatis menggulir untuk menampilkan konten dari node tersebut dalam tampilan.',
    add_scenario: 'Tambah Skenario',
    add_option: 'Tambah Opsi',
    an_error_occured: 'Terjadi kesalahan:',
    download_summary: 'Unduh Ringkasan',
    step_wise_analysis: 'Analisis Langkah demi Langkah',
    step: 'Langkah',
    upload_csv_file: 'Unggah File CSV',
    download_template_to_import: 'Unduh template contoh untuk diimpor',
    please_input_email: 'Silakan masukkan email.',
    email_at_least_three_characters:
      'Email harus terdiri dari minimal 3 karakter.',
    email_cannot_be_empty: 'Email tidak boleh kosong.',
    input_email_in_new_line:
      'Silakan masukkan email (masing-masing email dalam baris baru)',
    role: 'Peran',
    select_role: 'Silakan pilih Peran',
    select_group: 'Silakan pilih Grup',
    identification_number: 'Nomor Identifikasi (Opsional)',
    add_identification_number: 'Silakan tambahkan Nomor Identifikasi',
    pie_chart_of_all_categories:
      'Diagram lingkaran dari semua kategori berdasarkan penggunaannya di Sharelook.',
    total_sharesphere_question_answered_by_users:
      'Total pertanyaan ShareSphere yang dijawab oleh pengguna dalam organisasi saat ini, dengan kategori-kategori tersebut dan hasil keberhasilan serta kegagalannya.',
    voice_style_over_the_text:
      'Di mana Anda dapat menggunakan berbagai gaya suara pada teks yang Anda ketik bla bla bla Lorem Ipsum adalah teks contoh dalam industri percetakan dan penataan huruf. Lorem Ipsum telah menjadi standar teks contoh sejak tahun 1500-an,',
    input_your_question: 'Silakan masukkan pertanyaan Anda!',
    make_me_sales_manager:
      'contoh: Apa yang bisa membuat saya menjadi manajer penjualan',
    enter_the_number_relevant_document: 'Masukkan jumlah dokumen yang relevan',
    please_wait_loading_result: 'Silakan tunggu, memuat hasil...',
    no_result_found: 'Tidak ditemukan hasil, Coba ajukan pertanyaan yang lain',
    browser_doesnot_support_iframes: 'Browser Anda tidak mendukung iframe',
    total_duration: 'Total Durasi',
    number_of_messages: 'Jumlah Pesan',
    search_result: 'Hasil pencarian',
    count_result: '(1244 hasil)',
    your_other_interests: 'Minat Anda yang lain',
    your_total_score: 'Skor Total Anda',
    add_a_question: '+tambah pertanyaan',
    travia_question_empty: 'Daftar pertanyaan Travia kosong.',
    video_generation_is_on_queue: 'Pembuatan video Anda sedang dalam antrian!',
    checking_video_status: 'Memeriksa status video...',
    total_quizzes: 'Total Kuis',
    number_of_votes: 'Jumlah Suara',
    total_events: 'Total Acara',
    number_of_rates: 'Jumlah Penilaian',
    number_of_likes: 'Jumlah Suka',
    all_courses: 'Semua Kursus',
    total_questions: 'Total Pertanyaan',
    no_skill_journey: 'Tidak ada perjalanan keterampilan yang tersedia!',
    search_no_results: '- tidak ada hasil yang tersedia!',
    no_image_generated: 'Tidak ada Gambar yang Dihasilkan!',
    all_topic_in_this_lesson:
      'Semua topik dalam pelajaran ini akan dihapus. Ini tidak dapat dibatalkan.',
    content_has_been_generated: 'Konten telah dibuat untuk topik ini.',
    update_course_template: 'Perbarui Template Kursus',
    add_course_template: 'Tambah Template Kursus',
    create_course_now: 'Buat Kursus Sekarang',
    preview_course: 'Pratinjau Kursus',
    layout: 'Tata Letak',
    import_from_youtube: 'Impor dari Youtube',
    my_media_library: 'Perpustakaan Media Saya',
    bg_added: 'Latar belakang ditambahkan',
    add_bg: 'Tambah Latar Belakang',
    booked_schedule: 'Jadwal yang Dipesan',
    add_schedule: 'Tambah Jadwal',
    are_you_delete_schedule: 'Apakah Anda yakin ingin menghapus jadwal ini?',
    add_task: 'Tambah Tugas',
    update_calender: 'Perbarui Kalender',
    manage_cookies: 'Kelola Cookie',
    cookie_banner_text:
      'Kami menggunakan cookie untuk meningkatkan pengalaman penelusuran Anda, menganalisis lalu lintas situs web, dan mempersonalisasi konten. Privasi Anda penting bagi kami.',
    accept_all_cookies: 'Terima Semua Cookie',
    reject_all: 'Tolak Semua',
    customize: 'Sesuaikan',
    cookie_preferences_title: 'Preferensi Cookie & Pengaturan Privasi',
    privacy_subtitle:
      'Privasi Anda penting bagi kami. Pilih cookie yang ingin Anda izinkan. Anda dapat mengubah pengaturan ini kapan saja.',
    save_choices: 'Simpan Pilihan Saya',
    strictly_necessary: 'Sangat Diperlukan',
    strictly_necessary_desc:
      'Cookie ini penting agar situs web berfungsi dengan benar. Cookie ini memungkinkan fungsi dasar seperti navigasi halaman, pengiriman formulir, dan akses ke area aman. Situs web tidak dapat berfungsi dengan baik tanpa cookie ini.',
    analytics_performance: 'Analitik & Kinerja',
    analytics_performance_desc:
      'Cookie ini membantu kami memahami bagaimana pengunjung berinteraksi dengan situs kami dengan mengumpulkan dan melaporkan informasi secara anonim. Hal ini membantu kami meningkatkan kinerja dan pengalaman pengguna.',
    advertising_marketing: 'Periklanan & Pemasaran',
    advertising_marketing_desc:
      'Cookie ini digunakan untuk membuat pesan iklan lebih relevan bagi Anda. Cookie ini mencegah iklan yang sama muncul berulang kali dan memastikan iklan ditampilkan dengan benar untuk pengiklan.',
    tracking_social: 'Pelacakan & Media Sosial',
    tracking_social_desc:
      'Cookie ini memungkinkan fungsionalitas tambahan dan personalisasi, seperti fitur media sosial dan konten yang disesuaikan. Cookie ini dapat diatur oleh kami atau oleh penyedia pihak ketiga.',
    functional: 'Fungsional',
    functional_desc:
      'Cookie ini memungkinkan fitur tambahan seperti dukungan obrolan, bantuan langsung, dan fitur interaktif lainnya yang meningkatkan pengalaman Anda di situs kami.',
    your_rights: 'Hak Anda:',
    rights_description:
      'Anda dapat menarik persetujuan Anda kapan saja, mengakses data Anda, atau meminta penghapusannya kapan saja.',
    withdraw_consent: 'Tarik Semua Persetujuan',

    how_many_options: 'Berapa banyak opsi',
    add_content: 'Tambahkan Konten',
    downloads_center: 'Pusat Unduhan',
    sharelook_help_center: 'Pusat Bantuan Sharelook',
    channel_outline: 'Garis Besar Saluran',
    channel_objectives: 'Tujuan Saluran',
    no_sop_available: 'Daftar SOP tidak tersedia.',
    generate_world_summary: 'Buat Skenario',
    world_scenario: 'Skenario Dunia Nyata',
    drag_icon_hint: 'Tips: Seret ikon di kanvas untuk menempatkannya',
    drag_text_hint: 'Tips: Seret teks di kanvas untuk menempatkannya',
    edit_badge: 'Edit Lencana',
    create_new_badge: 'Lencana Baru',
    select_video_preview: 'Pilih video untuk pratinjau',
    certificate_title_required: 'Judul sertifikat wajib diisi',
    discard_changes: 'Batalkan Perubahan',
    edit_certificate: 'Edit Sertifikat',
    add_another_logo: 'Tambahkan Logo Lain',
    optional: 'Opsional',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Buat Misi Baru',
    quest_filter_title: 'Misi',
    sharelook_assistance: 'Bantuan Sharelook',
    upload_scorm_zip: 'Unggah File Scorm Zip',
    only_letters_numbers_space_dot_allowed:
      'Hanya huruf, angka, spasi, dan titik yang diperbolehkan!',
    video_playing: 'Sedang Diputar',
    course_price_message:
      '*Kursus ini hanya akan diterbitkan untuk pengguna dalam organisasi dan tidak dapat dijual di pasar.',
    lesson_must_be_positive: 'Jumlah pelajaran harus lebih dari 1',
    btn_proceed: 'Lanjutkan',
    rule_select_music: 'Silakan pilih musik',
    course_info: 'Informasi Kursus',
    content_selection: 'Pemilihan Konten',
    course_content_source: 'Sumber Konten Kursus',
    choose_how_to_source:
      'Pilih cara untuk mendapatkan konten untuk kursus ini:',
    automatic_selection: 'Pemilihan Otomatis',
    system_will_automatically_select_relavant_documents:
      'Sistem akan secara otomatis memilih dokumen yang relevan dari perpustakaan Anda',
    manual_selection: 'Pemilihan Manual',
    choose_specific_documents_from_your_library:
      'Pilih dokumen tertentu dari perpustakaan Anda',
    upload_files: 'Unggah File',
    upload_new_documents:
      'Unggah dokumen baru (PDF, DOC, DOCX, PPT, PPTX, TXT) - Maksimal 5 file',
    file: 'file',
    ready_to_upload: 'siap diunggah',
    clear_all: 'Hapus Semua',
    confirm_course_wide_premiew: 'Konfirmasi Pratinjau Kursus',
    generate_course_preview: 'Buat Pratinjau Kursus',
    instructions_across_the_course_to_generate:
      'Kami akan menerapkan instruksi Anda ke seluruh kursus untuk membuat pratinjau. Tinjau semuanya terlebih dahulu, lalu pilih untuk menyimpan atau membatalkan perubahan.',
    instruction_to_preview_course_wide: 'Instruksi untuk pratinjau kursus:',
    edit_content: 'Edit Konten',
    manage_course_template: 'Kelola Template Kursus',
    undo: 'Urungkan',
    apply_changes: 'Terapkan Perubahan',
    characters: 'karakter',
    apply_all: 'Terapkan Semua',
    apply_to_all: 'Terapkan ke Semua',
    use_this_content: 'Gunakan Konten Ini',
    original: 'Asli',
    edited: 'Diedit',
    edited_content_preview: 'Pratinjau Konten yang Diedit',
    apply_edits_to_all_topices: 'Terapkan editan ke semua topik?',
    current_editing_instructions_across_the_whole_course:
      'Ini akan menerapkan instruksi pengeditan Anda ke seluruh kursus. Anda dapat meninjau pratinjau gabungan sebelum menyimpan.',
    edit_content_instructions: 'Instruksi Edit Konten',
    generate_content_for_this_topic_instruction:
      'Hasilkan konten untuk topik ini menggunakan instruksi Anda',
    descrip_edit_content:
      'Jelaskan bagaimana mengedit konten ini (misalnya, persingkat, sederhanakan, ubah gaya bahasa)',
    try_short_clear_direcctives:
      'Cobalah instruksi singkat dan jelas. Contoh: “persingkat menjadi 100 kata, pertahankan poin penting”, “sederhanakan bahasa”, “buat lebih ringkas dan hilangkan pengulangan”.',
    we_preserve_the_core_meaning:
      'Kami menjaga makna inti sambil menerapkan instruksi Anda.',
    feedback_optional: 'Umpan Balik (Opsional)',
    write_your_feedback_here: 'Tulis umpan balik Anda di sini',
    from_web: 'Dari Web',
    from_desktop: 'Dari Desktop',
    pleae_wait_processing: 'Harap tunggu, sedang diproses...',
    create_simulation_from_screen_capture: 'Buat Simulasi dari Perekaman Layar',
    sharelook_not_found: 'ShareLook Tidak Ditemukan',
    sharelook_screen_capture_application_not_be_opened:
      'Aplikasi ShareLook untuk perekaman layar tidak dapat dibuka. Mungkin belum terinstal di komputer Anda.',
    download_sharelook: 'Unduh ShareLook',
    launch_sharelook_application: 'Jalankan Aplikasi ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Ini akan membuka aplikasi ShareLook untuk perekaman layar.',
    sharelook_dosenot_open:
      'Jika ShareLook tidak terbuka, mungkin belum terinstal di komputer Anda.',
    open_sharelook: 'Buka ShareLook',
    download_app: 'Unduh Aplikasi',
    background_image_setting: 'Pengaturan Gambar Latar Belakang',
    current_image: 'Gambar Saat Ini',
    change_image: 'Ubah Gambar',
    remove_image: 'Hapus Gambar',
    no_background_image_selected: 'Tidak ada gambar latar yang dipilih',
    add_image: 'Tambahkan Gambar',
    this_will_open_for_screen_recording:
      'Ini akan membuka aplikasi ShareLook untuk perekaman layar.',
    ai_image_generation: 'Pembuatan Gambar AI',
    image_edit: 'Edit Gambar',
    text_to_image: 'Teks ke Gambar',
    output_gallary: 'Galeri Hasil',
    instant_generation: 'Siap untuk pembuatan instan',
    prompt_and_unleash_the_power:
      'Masukkan perintah Anda dan rasakan kekuatannya',
    use_this_image: 'Gunakan Gambar Ini',
    error_generating: 'Terjadi kesalahan saat membuat.',
    generation_tips: 'Tips Pembuatan',
    detailed_descriptions_for_more_accurate_results:
      'Gunakan deskripsi yang detail untuk hasil yang lebih akurat',
    reference_image: 'Gambar Referensi',
    select_pixel_image: 'Pilih Gambar Piksel',
    max_mb: 'Maks 50MB',
    please_enter_text_to_appear_image:
      'Masukkan teks yang akan muncul di gambar',
    enter_text_to_apear_in_the_image:
      'Masukkan teks untuk ditampilkan di gambar',
    generate_image: 'Buat Gambar',
    prompt_assistant: 'Asisten Prompt',
    generate_image_using_suggested_prompt:
      'Buat gambar menggunakan prompt yang disarankan',
    talk_to_ai_about_the_image_generate:
      'Bicaralah dengan AI tentang gambar yang ingin Anda buat',
    ask_for_prompt_suggestions: 'Minta saran prompt...',
    enter_a_search_term_to_find_stock_images:
      'Masukkan istilah pencarian untuk menemukan gambar stok',
    choose_your_content_source: 'Pilih sumber konten Anda:',
    upload_new_document_from_your_device:
      'Unggah dokumen baru dari perangkat Anda',
    automatic_library_selection: 'Pemilihan Otomatis dari Perpustakaan',
    system_automatically_selects_relevant_document:
      'Sistem secara otomatis memilih dokumen yang relevan',
    manual_library_selection: 'Pemilihan Manual dari Perpustakaan',
    generate_content: 'Buat Konten',
    add_to_current_page: 'Tambahkan ke Halaman Saat Ini',
    generate_bullet_points: 'Buat Poin-Poin',
    generating: 'Sedang Membuat',
    this_may_take_a_few_moments: 'Ini mungkin memerlukan beberapa saat',
    apply_to_page: 'Terapkan ke Halaman',
    scenario_escription: 'Deskripsi Skenario:',
    feedback: 'Umpan Balik',
    form_mode: 'Mode Formulir',
    chat_mode: 'Mode Obrolan',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Ini akan membuat kelanjutan dari cerita yang dipilih menggunakan AI.',
    continue_this_story_question: 'Lanjutkan cerita ini?',
    continue_this_story: 'Lanjutkan Cerita Ini',
    what_will_happen: 'Apa yang akan terjadi:',
    the_ai_will_analyze_the_existing_story_content:
      'AI akan menganalisis konten cerita yang ada',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Hasilkan kelanjutan alami dengan nada dan gaya yang sama',
    create_new_content_that_build_upon_the_current_narrative:
      'Buat konten baru yang melanjutkan narasi saat ini',
    this_process_may_take_a_few_moments_to_complete:
      'Proses ini mungkin memerlukan beberapa saat.',
    no_existing_stories_found_for_this_course:
      'Tidak ada cerita yang ditemukan untuk kursus ini.',
    create_your_first_story: 'Buat Cerita Pertama Anda',
    existing_stories: 'Cerita yang Ada',
    create_new_story: 'Buat Cerita Baru',
    tone: 'Nada',
    style: 'Gaya',
    genre: 'Genre',
    loading_your_stories: 'Memuat cerita Anda...',
    edit_story: 'Edit Cerita',
    story_preferences: 'Preferensi Cerita',
    please_input_your: 'Silakan masukkan',
    add_character_names_and_press_enter:
      'Tambahkan nama karakter dan tekan Enter',
    select_or_type_your: 'Pilih atau ketik',
    enter_your: 'Masukkan',
    position_of_the_story_in_the_lesson:
      'Posisi cerita dalam pelajaran. Cerita akan ditambahkan sebagai blok di posisi yang ditentukan.',
    save_previous_content_on_the_pages: 'Simpan konten sebelumnya di halaman',
    the_existing_content_in_the_selected_pages:
      'Konten yang ada di halaman yang dipilih akan diganti dengan cerita yang dibuat.',
    real_world_scenario: 'Skenario Dunia Nyata',
    add_optional_instructions:
      'Tambahkan instruksi opsional (nada, panjang, audiens, dll.)',
    ready_to_enerate_your_real_world_scenario:
      'Siap untuk membuat skenario dunia nyata Anda',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Klik "Buat Skenario Dunia Nyata" untuk membuat skenario realistis berdasarkan konten pelajaran Anda.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI akan menganalisis topik dan konten pelajaran Anda',
    generate_a_practical_real_world_scenario:
      'Buat skenario dunia nyata yang praktis',
    you_can_then_edit_and_customize_the_result:
      'Anda kemudian dapat mengedit dan menyesuaikan hasilnya',
    add_it_as_a_new_page_to_your_lesson:
      'Tambahkan sebagai halaman baru ke pelajaran Anda',
    regenerate_with_instructions: 'Hasilkan ulang dengan Instruksi',
    add_real_world_scenario: 'Tambahkan Skenario Dunia Nyata',
    generate_real_world_scenario: 'Hasilkan Skenario Dunia Nyata',
    simulation_has_been_stopped: 'Simulasi telah dihentikan!',
    loading_simulation: 'Memuat Simulasi...',
    you_have_exhausted_all_the_attempts:
      'Anda telah menggunakan semua percobaan',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Pelajari skenario pada halaman ini dan pilih jawaban yang benar dari opsi di bawah.',
    attempts_limit_reached:
      'Batas percobaan tercapai. Anda bisa bermain lagi tetapi skor Anda tidak akan disimpan.',
    play_again: 'Main Lagi',
    import_music_from_computer: 'Impor musik dari komputer.',
    more: 'lebih',
    no_badge_yet: 'Belum ada lencana',
    competition_filter: 'Filter Kompetisi',
    global_leaderboard: 'Papan Peringkat Global',
    placeholder_for_the_global_leaderboard:
      'Ini adalah placeholder untuk Papan Peringkat Global.',
    badge_editor: 'Editor Lencana',
    adjust_the_appearance_of_this_badge_icon:
      'Sesuaikan tampilan ikon lencana ini. Perubahan hanya berlaku untuk lencana ini.',
    badge_style: 'Gaya Lencana',
    the_image_must_be_pixels: 'Gambar harus 200x200 piksel.',
    badge_name: 'Nama Lencana',
    badge_descrription: 'Deskripsi Lencana',
    enter_badge_criteria: 'Masukkan kriteria lencana',
    discard: 'Buang',
    badge_enable: 'Lencana Diaktifkan',
    award_users_with_badges_to_highlight_the_milestones:
      'Berikan lencana kepada pengguna untuk menyoroti pencapaian dalam perjalanan belajar mereka.',
    badge_types: 'Jenis Lencana',
    enable_or_disable_specific_badge_types_for_your_users:
      'Aktifkan atau nonaktifkan jenis lencana tertentu untuk pengguna Anda.',
    levels_enabled: 'Level Diaktifkan',
    level_rules: 'Aturan Level',
    points: 'Poin',
    add_new_level: 'Tambahkan Level Baru',
    add_level: 'Tambahkan Level',
    points_enabled: 'Poin Diaktifkan',
    learning_activities_and_encourage_healthy_competition:
      'Berikan poin untuk berbagai aktivitas belajar dan dorong kompetisi yang sehat.',
    award_points: 'Berikan Poin',
    the_following_equates_the_value_of_one_item_completion:
      'Berikut ini setara dengan nilai penyelesaian satu item',
    general: 'umum',
    others: 'Lainnya',
    certificate: 'Sertifikat',
    quiz_passed: 'Kuis berhasil',
    tip_approved: 'Tips Disetujui',
    tip_liked: 'Tips Disukai',
    rewards: 'Hadiah',
    offer_discounts_when_learners_achieve:
      'Tawarkan diskon ketika peserta mencapai sejumlah poin, lencana, atau level.',
    give_rewards: 'Berikan Hadiah',
    discount_course_purchases_by: 'Diskon pembelian kursus sebesar',
    with_points_more_than: 'dengan poin lebih dari',
    with_badges_more_than: 'dengan lencana lebih dari',
    with_level_upwards_more_than: 'dengan level lebih dari',
    leaderboard: 'Papan Peringkat',
    leaderboard_enabled: 'Papan Peringkat Diaktifkan',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Papan peringkat memberi pengguna gambaran kemajuan belajar mereka dalam poin dibandingkan orang lain.',
    show_levels: 'Tampilkan Level',
    show_points: 'Tampilkan Poin',
    show_badges: 'Tampilkan Lencana',
    show_courses: 'Tampilkan Kursus',
    show_certificates: 'Tampilkan Sertifikat',
    leaderboard_settings: 'Pengaturan Papan Peringkat',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Siapkan pengalaman papan peringkat yang menarik untuk meningkatkan motivasi belajar.',
    award_users_with_points_for_different_learning_activities:
      'Berikan poin kepada pengguna untuk berbagai aktivitas belajar.',
    badge_set: 'Set Lencana',
    choose_the_type_of_badges_your_users:
      'Pilih jenis lencana yang akan diperoleh pengguna saat belajar.',
    levels: 'Level',
    Levels_represent_the_stages:
      'Level mewakili tahapan dalam perjalanan belajar pengguna.',
    enabled: 'Diaktifkan',
    disabled: 'Dinonaktifkan',
    quick_select: 'Pilih Cepat',
    yesterday: 'Kemarin',
    last_week: 'Minggu lalu',
    Last_month: 'Bulan lalu',
    last_quarter: 'Kuartal lalu',
    historical_leaderboard: 'Papan Peringkat Historis',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Lacak kinerja Anda dan lihat peringkat Anda di antara rekan-rekan.',
    time_period: 'Periode Waktu',
    page_of: 'Halaman 1 dari 1',
    edit_competition: 'Edit Kompetisi',
    create_competition: 'Buat Kompetisi',
    arrow_right: 'panah-kanan',
    update_competition: 'Perbarui Kompetisi',
    competition_title: 'Judul Kompetisi',
    enter_competition_title: 'Masukkan judul kompetisi',
    enter_competition_description: 'Masukkan deskripsi kompetisi',
    leaderboard_skill: 'Keahlian',
    select_a_skill: 'Pilih keahlian',
    no_skills_found: 'Tidak ditemukan keahlian',
    competition_period: 'Periode Kompetisi',
    add_badge_rule: 'Tambahkan Aturan Lencana',
    create_badge: 'Buat Lencana',
    add_level_rule: 'Tambahkan Aturan Level',
    selected_participants: 'Peserta Terpilih',
    no_participants: 'Tidak ada peserta',
    start_end_date: 'Tanggal Mulai–Selesai',
    created_date: 'Dibuat oleh',
    new_competition: 'Kompetisi Baru',
    competitions_list: 'Daftar Kompetisi',
    search_competitions: 'Cari kompetisi...',
    are_you_sure_you_want_to_delete_the_competition:
      'Apakah Anda yakin ingin menghapus kompetisi ini?',
    history: 'Riwayat',
    export: 'Ekspor',
    search_by_name: 'Cari berdasarkan nama...',
    no_historical_data_available_for_the_selected_period:
      'Tidak ada data historis untuk periode yang dipilih.',
    no_leaderboard_data_available: 'Tidak ada data papan peringkat tersedia.',
    competitions: 'Kompetisi',
    leaderboards: 'Papan Peringkat',
    welcome_back: 'Selamat Datang Kembali',
    track_your_performance_and_see: 'Lacak kinerja Anda dan lihat:',
    team_leaderboard: 'Papan Peringkat Tim',
    try_again: 'Coba Lagi',
    no_competitions_for_search: 'Tidak ada kompetisi tersedia untuk',
    no_competitions_available: 'Tidak ada kompetisi tersedia',
    no_competitions_matching_search:
      'Tidak ditemukan kompetisi yang cocok dengan pencarian Anda. Coba ubah kata kunci atau periksa kembali nanti.',
    no_competitions_general:
      'Saat ini tidak ada kompetisi yang disiapkan. Periksa kembali nanti atau hubungi administrator untuk membuat kompetisi baru.',
    media_management: 'Manajemen Media',
    badgess_set: 'Set Lencana',
    choose_the_default_visual_style_for_badge:
      'Pilih gaya visual default untuk ikon lencana yang digunakan di seluruh platform.',
    enable_badges: 'Aktifkan Lencana',
    add_badge: 'Tambahkan Lencana',
    min: 'Min',
    max: 'Maks',
    your_rank: 'Peringkat Anda',
    your_points: 'Poin Anda',
    your_level: 'Level Anda',
    rank: 'Peringkat #',
    level: 'Level',
    progress: 'Kemajuan',
    new_folder: 'Folder Baru',
    file_upload: 'Unggah File',
    writer: 'Penulis',
    text_documents: 'Dokumen Teks',
    spreadsheets: 'Spreadsheet',
    impress: 'Presentasi Impress',
    presentations: 'Presentasi',
    capture_desktop_screen: 'Tangkap Layar Desktop',
    capture_desktop_screens: 'Tangkap Layar Desktop',
    your_documents: 'Dokumen Anda',
    manage_your_videos_images_audio_files:
      'Kelola video, gambar, file audio, dan aset lain yang digunakan dalam pembuatan konten.',
    your_organization_documents: 'Dokumen Organisasi Anda',
    keep_your_organization_creative_assets_organized:
      'Jaga aset kreatif organisasi tetap terorganisir dan mudah diakses—permudah kolaborasi dan produksi konten.',
    your_public_documents: 'Dokumen Publik Anda',
    curated_collection_of_media_assets_available:
      'Koleksi aset media yang dikurasi tersedia untuk semua orang—jelajahi, gunakan kembali, dan buat konten.',
    your_download_center_documents: 'Dokumen Pusat Unduhan Anda',
    repository_of_approved_media_assets_for_download:
      'Repositori aset media yang disetujui untuk diunduh dan digunakan dalam proyek Anda.',
    search_files_and_folders: 'Cari file dan folder...',
    home: 'Beranda',
    folders: 'Folder',
    folder_name: 'Nama Folder',
    owner: 'Pemilik',
    last_updated: 'Terakhir Diperbarui',
    action: 'Aksi',
    no_folders_found: 'Tidak ada folder ditemukan',
    files: 'File',
    enabling_ai: 'Mengaktifkan AI...',
    rename: 'Ganti Nama',
    copy: 'Salin',
    move: 'Pindahkan',
    verson_history: 'Riwayat Versi',
    manage_permission: 'Kelola Izin',
    generate_audit_report: 'Buat Laporan Audit',
    last_edited: 'Terakhir Diedit',
    no_files_found: 'Tidak ada file ditemukan',
    are_you_sure_you_want_to_make_this_item_public:
      'Apakah Anda yakin ingin membuat item ini menjadi publik? Item ini akan disalin ke perpustakaan publik Anda.',
    move_to_organization: 'Pindahkan ke Organisasi',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Apakah Anda yakin ingin menyalin item ini ke perpustakaan organisasi Anda?',
    are_you_sure_you_want_to_make_this_item_private:
      'Apakah Anda yakin ingin membuat item ini menjadi pribadi? Item ini akan disalin ke perpustakaan pribadi Anda.',
    date_modified: 'Tanggal Diubah',
    workflow_management: 'Manajemen Alur Kerja',
    configure_editors_approvers_and_viewers_for_this_document:
      'Konfigurasi editor, penyetuju, dan pemirsa untuk dokumen ini.',
    error_Loading_editor: 'Terjadi Kesalahan Saat Memuat Editor',
    debug_info: 'Info Debug',
    loading_editor: 'Memuat Editor...',
    submitted_for_review: 'Dikirim untuk Ditinjau',
    editors: 'Editor',
    no_editors_added_yet:
      'Belum ada editor ditambahkan. Klik "Tambah Editor" untuk menambahkan.',
    add_editor: 'Tambah Editor',
    approvers: 'Penyetuju',
    no_approvers_added_yet:
      'Belum ada penyetuju ditambahkan. Klik "Tambah Penyetuju" untuk menambahkan.',
    add_approvers: 'Tambah Penyetuju',
    viewer: 'Pemirsa',
    no_viewers_added_yet:
      'Belum ada pemirsa ditambahkan. Klik "Tambah Pemirsa" untuk menambahkan.',
    add_viewer: 'Tambah Pemirsa',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Apakah Anda yakin ingin menghapus item yang dipilih?'
  },
  v3: {
    monthly_ai_credit_limit: 'Untuk mengubah batas kredit AI Anda, silakan hubungi',
    remaining_credits_text: 'Kredit AI yang Tersisa: <0>{{ remaining_credits }}</0> kredit <1/><2/> <3>. Untuk mengubah batas kredit AI Anda, silakan hubungi </3> <4>admin@sharelook.com</4>.',
    reportShareSphere: 'SHARESPHERE',
    overview: 'Ikhtisar Kategori',
    triviaReport: 'Kategori ShareSphere',
    overviewGraph: 'Grafik Ikhtisar Kategori',
    category: 'Kategori',
    phCategory: 'Pilih Kategori',
    podcast: 'Podcast, Musik dan Cerita',
    pastPodcast: 'Podcast Sebelumnya',
    upcomingPodcast: 'Podcast Mendatang',
    podcastLanguageTitle: 'Bahasa podcast, musik & cerita',
    podcastLanguageCheckbox: 'AI menghasilkan bahasa untuk podcast saya',
    howRate: 'Bagaimana Anda menilai podcast ini?',
    podcastSubmit: 'Kirim',
    podcastGuest: 'Pembicara Tamu:',
    podcastReview: 'Ulasan',
    podcastEpishode: 'Episode',
    podcastEnd: 'Podcast telah berakhir',
    date_podcast: 'Tanggal Podcast',
    skill_not_found: 'Maaf! Tidak ada perjalanan keterampilan ditemukan.',
    coaching: 'Pelatihan',
    webinar: 'Webinar',
    public_conference: 'Konferensi Publik',
    skill_journey_subtitle:
      'Tambahkan pengaturan ke perjalanan keterampilan Anda dan pilih siapa yang dapat melihat dan berinteraksi dengan perjalanan keterampilan Anda.',
    enable_white_label: 'Aktifkan label putih',
    create_new_event_org: 'Buat acara baru untuk organisasi Anda.',
    create_new_event_marketplace: 'Buat acara baru untuk marketplace.',
    create_new_event_both:
      'Buat acara baru untuk organisasi Anda dan marketplace.',
    event_outline: 'Harap Masukkan Garis Besar Acara',
    event_obj: 'Harap Masukkan Tujuan Acara',
    event_description: 'Harap Masukkan Deskripsi Acara',
    create_new_metamaze_org: 'Buat MetaMaze baru untuk organisasi Anda.',
    create_new_metamaze_marketplace: 'Buat MetaMaze baru untuk marketplace.',
    create_new_metamaze_both:
      'Buat MetaMaze baru untuk organisasi Anda dan marketplace.',
    add_key_words: 'Tambahkan kata kunci',
    press_enter_make_keyword: 'Tekan Enter Untuk Membuat Kata Kunci',
    disable_skip_quiz: 'Nonaktifkan Lewati Kuis',
    warning_complete_quiz: 'Harap selesaikan kuis untuk melanjutkan.',
    signup_email_verification:
      'Kami telah mengirimkan tautan verifikasi ke alamat yang Anda berikan. Silakan kunjungi tautan tersebut untuk mengonfirmasi pendaftaran Anda.',
    verifying_registration: 'Memverifikasi pendaftaran akun...',
    reset_password_linK:
      'Kami telah mengirim tautan ke alamat yang Anda berikan. Silakan kunjungi tautan tersebut untuk mengatur kata sandi baru.',
    reset_email_error:
      'Pengguna tidak ditemukan dengan email ini, silakan coba lagi menggunakan nama pengguna!',
    first_name: 'Nama Depan',
    last_name: 'Nama Belakang',
    error_firstName: 'Silakan masukkan nama depan Anda',
    error_sharebot_organization: 'Silakan masukkan Organisasi Anda',
    error_lastName: 'Silakan masukkan nama belakang Anda',
    private_conference: 'Konferensi Pribadi',
    public_conference: 'Konferensi Publik',
    discussion_room: 'Ruang Diskusi',
    training_no_courses: 'Anda saat ini belum mengikuti kursus apa pun.',
    training_no_events: 'Anda saat ini belum mengikuti acara apa pun.',
    allow_sharing_trainer_info: 'Izinkan berbagi alamat email di marketplace',
    error_username_space: `Nama pengguna tidak boleh mengandung spasi.`,
    error_sharebot_organization_space: `Nama organisasi tidak boleh mengandung spasi.`,
    edit_permission: 'Edit izin',
    valid_price: 'Harga harus lebih dari 0',
    course_price_message: `*kursus hanya akan dipublikasikan ke jumlah pengguna yang dibeli oleh organisasi dan 
tidak akan dapat dijual kembali di marketplace`,
    valid_edit_price: 'Harga edit harus lebih kecil dari harga beli.',
    my_calendar: 'Kalender Saya',
    error_valid_firstName: 'Silakan masukkan nama depan yang valid.',
    error_valid_organization: 'Silakan masukkan nama Organisasi yang valid.',
    error_valid_lastName: 'Silakan masukkan nama belakang yang valid.',
    error_name_spaces: `Nama tidak boleh mengandung spasi`,
    items: 'Item',
    publish_to_channel: 'Terbitkan ke Koleksi Saluran Saya',
    create_a_channel: 'Buat Saluran Saya',
    create_a_trivia: 'Permainan Trivia',
    create_a_new_channel: 'Buat Saluran Baru',
    add_videos: 'Tambahkan Video',
    save_and_continue: 'Simpan & Lanjutkan',
    channel: 'Saluran',
    channels: 'Saluran',
    view_channel: 'Lihat Saluran',
    edit_channel: 'Edit Saluran',
    delete_channel: 'Hapus Saluran',
    my_video_channels: 'Saluran Video Saya',
    training_no_channel: 'Anda saat ini belum mengikuti saluran apa pun.',
    monthly_price_required: 'Harga bulanan wajib diisi',
    yearly_price_required: 'Harga tahunan wajib diisi',
    one_time_price_required: 'Harga sekali bayar wajib diisi',
    marketplace_quantity: 'USD',
    report_webinar: 'WEBINAR',
    report_coaching: 'PELATIHAN',
    report_channel: 'SALURAN',
    report_public_conference: 'KONFERENSI PUBLIK',
    report_maze: 'MAZE',
    channel: 'Saluran',
    edit_price: 'Edit Harga ($)',
    quantity: 'Kuantitas',
    payment_type: 'Jenis Pembayaran',
    total_amount: 'Jumlah Total ($)',
    net_amount: 'Jumlah Bersih ($)',
    edit_option: 'Edit Opsi',
    marketplace_price: 'Harga ($)',
    market_name: 'Nama',
    duration_min: 'Durasi (Menit)',
    users_total: 'Total Pengguna',
    sales_total: 'Total Penjualan (USD)',
    search_coaching: 'Cari Pelatihan',
    search_channel: 'Cari Saluran',
    search_webinar: 'Cari Webinar',
    search_maze: 'Cari Maze',
    search_public_conference: 'Cari Konferensi Publik',
    buyer_type: 'Tipe Pembeli',
    quanity: 'Kuantitas',
    channel_unit_amount: 'Jumlah Bersih ($)',
    channel_updated_at: 'Tanggal Pembaruan',
    month_price: 'Harga (Bulanan)',
    year_price: 'Harga (Tahunan)',
    one_time_price: 'Harga (Sekali)',
    sharebot_organization: 'Tambahkan nama organisasi baru',
    share_sphere: 'ShareSphere',
    ai_course_title: 'Judul Kursus',
    ai_input_course_title: 'Silakan masukkan judul kursus!',
    learning_objective_label: 'Tujuan Pembelajaran',
    learning_objective_message: 'Silakan masukkan tujuan pembelajaran!',
    standard_question: 'Apakah ada standar yang perlu diikuti peserta?',
    standard_details_label: 'Detail Standar',
    standard_details_message: 'Silakan masukkan detail standar!',
    estimated_duration_label: 'Durasi Perkiraan Kursus (dalam menit)',
    estimated_duration_message: 'Silakan masukkan durasi perkiraan!',
    min_duration_message: 'Durasi minimum adalah 5 menit.',
    ai_mins: '25 menit',
    industry_specific_question: 'Apakah kursus ini spesifik industri?',
    industry_label: 'Sebutkan Industri',
    industry_message: 'Silakan masukkan industri!',
    ai_course_creation: 'Pembuatan Kursus AI',
    course_generated: 'Kursus Dihasilkan Oleh Sharelook',
    ai: 'AI',
    ai_you: 'Anda',
    ai_prompt_ready: 'Prompt Anda siap. Anda sekarang siap membuat daftar isi.',
    ai_unable_respond:
      'Maaf! AI tidak dapat merespons prompt Anda. Silakan coba lagi.',
    ai_hide_toc: 'Sembunyikan Daftar Isi',
    ai_preview_toc: 'Pratinjau Daftar Isi',
    ai_generate_toc_now: 'Buat Daftar Isi Sekarang',
    ai_creation_course_title: 'Judul Kursus:',
    ai_creation_industry_specific: 'Apakah Ini Spesifik Industri:',
    ai_creation_industry: 'Industri:',
    ai_creation_standard_needed:
      'Apakah Ada Standar yang Harus Diikuti Peserta?:',
    ai_creation_standard_details: 'Detail Standar:',
    ai_creation_estimated_duration: 'Durasi Perkiraan Kursus (Dalam Menit):',
    minutes: 'menit',
    ai_creation_learning_objective: 'Tujuan Pembelajaran:',
    setup_again: 'Atur Ulang',
    ai_creation_confirm_title:
      'Apakah Anda yakin ingin mengatur ulang formulir?',
    ai_creation_confirm_content:
      'Chat & semua konten yang telah Anda hasilkan akan direset.',
    ai_toc: 'Daftar Isi',
    ai_note_topic:
      'Catatan: Anda dapat seret dan lepas untuk menyusun ulang topik dalam pelajaran.',
    ai_add_topic: '+ Tambah Topik',
    add_topic: 'Tambah Topik',
    add_lesson: 'Tambah Pelajaran',
    add_new_lesson: 'Tambah Pelajaran Baru',
    ai_add_lesson: '+ Tambah Pelajaran',
    attention: 'Perhatian',
    before_varifying: 'Sebelum Verifikasi',
    ai_save_later: 'Simpan Nanti',
    ai_download_word_doc: 'Unduh sebagai Dokumen Word',
    ai_download_course_word_doc: 'Unduh Kursus sebagai Dokumen Word',
    ai_create_course_button: 'Buat Kursus',
    ai_generate_course_content: 'Buat Konten Kursus',
    ai_out_of: 'dari',
    ai_subtopic_failed_content:
      'subtopik gagal menghasilkan konten. Klik "Buat Konten Kursus" lagi untuk menghasilkan konten hanya untuk subtopik tersebut.',
    ai_edit_topic: 'Edit Topik',
    ai_edit_lesson_title: 'Edit Judul Pelajaran',
    ai_save_topic: 'Simpan Topik',
    ai_save: 'Simpan',
    ai_save_lesson_title: 'Simpan Judul Pelajaran',
    ai_add_new_topic: 'Tambah Topik Baru',
    ai_download_ref: 'Unduh dengan Referensi',
    ai_download_ref_content:
      'Ini akan mengunduh kursus sebagai dokumen Word dengan referensi.',
    ai_download_without_ref: 'Unduh tanpa Referensi',
    ai_download_two_word: 'Dua dokumen Word akan diunduh:',
    ai_download_two_word_content_one:
      '- satu berisi konten utama tanpa referensi,',
    ai_download_two_word_content_two:
      'dan yang lainnya hanya berisi daftar referensi tanpa konten.',
    ai_manage_content: 'Kelola Konten',
    ai_add_content_from_internet: '+Tambah Konten dari Internet',
    ai_confirm_start: 'Konfirmasi Mulai',
    ai_Verify: 'Verifikasi',
    ai_undo_warning:
      'Proses ini mungkin memakan waktu. Jangan tutup jendela ini hingga selesai karena tidak dapat dibatalkan.',
    ai_verified_content:
      'Anda telah memverifikasi konten. Setelah dikonfirmasi, Anda tidak akan dapat kembali ke chat dengan asisten AI dengan konten saat ini.',
    ai_want_proceed: 'Apakah Anda yakin ingin melanjutkan?',
    upload_simulation: 'Unggah Simulasi',
    name_simulation: 'Nama Simulasi',
    selected_simulation_files: 'File Simulasi Terpilih',
    score_between_one_hundred: 'Skor Anda harus antara 1 dan 100.',
    are_sure_simulation: 'Apakah Anda yakin ingin menghapus file simulasi ini?',
    required_simulation: 'Skor wajib diisi',
    required_section_file: 'File bagian wajib diisi',
    simulation: 'Simulasi',
    simulation_quiz_games: 'Perlu menambahkan kuis dalam permainan',
    simulation_alert_des:
      'Anda hanya dapat menambahkan permainan jika semua pertanyaan memiliki jenis jawaban tunggal atau ganda.',
    alert_info: 'info',
    ai_number_quiz: 'Jumlah Kuis',
    ai_point: 'Poin',
    ai_points: 'Poin',
    val_required: 'Wajib Diisi',
    games: 'Permainan',
    add_simulation: 'Tambah Simulasi',
    text_tiewer: 'Penampil Teks',
    back_to_account: 'Kembali ke Akun',
    delete_account: 'Hapus Akun',
    delete_account_title: 'Hapus Akun ???',
    delete_account_subtitle: 'Anda dapat menghapus akun Anda dari sini.',
    delete_account_cannot_undo:
      'Anda akan menghapus akun Anda. Tindakan ini tidak dapat dibatalkan.',
    account_org_profile:
      'Anda juga akan kehilangan semua kursus yang telah Anda buat, profil organisasi Anda dan semua pengaturan Anda.',
    deleting_account_database:
      'Menghapus akun Anda akan menghapus semua data Anda dari database kami.',
    account_confirm_delete: 'Apakah Anda yakin ingin menghapus akun Anda?',
    action_cannot_be_undone: 'Tindakan ini tidak dapat dibatalkan.',
    account_delete_message_success: 'Akun Anda telah berhasil dihapus.',
    message_edit: 'Edit',
    message_delete: 'Hapus',
    message_reply: 'Balas',
    attached_file: 'File Terlampir',
    attach_file: 'Lampirkan File',
    attach_des: '25 MB, ukuran file maksimum',
    view: 'Lihat',
    go_to_marketplace: 'Pergi ke Marketplace',
    learning_center: 'Pusat Pembelajaran',
    knowledge_center: 'Pusat Pengetahuan',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Bagaimana saya bisa membantu Anda hari ini?',
    my_organization: 'Organisasi Saya',
    world_knowledge: 'Pengetahuan Dunia',
    welcome_to_sharelook: 'Selamat Datang di Sharelook!',
    sharelook_you_want_go: 'Ke mana Anda ingin pergi hari ini?',
    shareLook_learning_management_system:
      'Akses sistem manajemen pembelajaran ShareLook untuk membuat atau mengakses sumber belajar seperti acara langsung dan kursus dalam organisasi Anda di ShareLook.',
    shareLook_powerful_ai_system:
      'Akses sistem AI canggih ShareLook di mana Anda dapat mengunggah dokumen pdf dan mendapatkan wawasan bermanfaat dalam hitungan detik. Dapatkan jawaban cepat berdasarkan sumber daya yang diunggah di organisasi Anda atau dapatkan jawaban dari sistem AI umum kami di bagian pengetahuan dunia.',
    edit_now: 'Edit Sekarang',
    sharelook_log_out: 'Anda telah keluar dari Sharelook. Silakan Login!',
    sorry_error: 'Maaf! Kami mengalami kesalahan.',
    login: 'Masuk',
    refresh_page: 'Muat Ulang Halaman',
    just_a_moment: 'Tunggu Sebentar',
    enter_lname_fname:
      'Silakan masukkan nama depan dan nama belakang Anda untuk melanjutkan.',
    procced_to_sharelook: 'Lanjut ke Sharelook',
    option_one: 'Opsi 1',
    option_two: 'Opsi 2',
    selected_image: 'Gambar Terpilih:',
    add_text: 'Tambah Teks',
    linkdin_is_required: 'Linkedin wajib diisi.',
    bio_is_required: 'Bio wajib diisi.',
    save_user_information: 'Simpan Informasi Pengguna',
    select_all: 'Pilih Semua',
    enable_ai: 'Aktifkan AI',
    load_more: 'Muat Lebih Banyak',
    channel_id: 'ID Saluran.',
    send: 'Kirim',
    v4: 'Informasi',
    subscription: 'Langganan',
    reset_user_flag: 'RESET TANDA PENGGUNA',
    delete_my_accont: 'Hapus akun saya',
    sharebot_sub_error: 'Gagal mengambil langganan. Coba Lagi!',
    sharebot_no_sub: 'Saat ini Anda tidak memiliki langganan aktif.',
    sharebot_dont_sub: 'Anda tidak memiliki langganan sebelumnya.',
    sharebot_prev_sub: 'Langganan Sebelumnya',
    sharebot_sub: 'Langganan ShareBot',
    sharebot_un_sub: 'Berhenti Langganan ShareBot',
    sharebot_no_available: 'Deskripsi Tidak Tersedia',
    sharebot_start_date: 'Tanggal Mulai:',
    sharebot_end_date: 'Tanggal Berakhir:',
    sharebot_sure: 'Apakah Anda yakin?',
    sharebot_do_you_want: 'Apakah Anda ingin',
    unsubscribe: 'berhenti berlangganan',
    unsubscribe_what: 'berhenti berlangganan?',
    subscribe: 'berlangganan',
    subscribe_what: 'berlangganan?',
    subscribe_now: 'berlangganan Sekarang',
    confirm: 'Konfirmasi',
    sharebot_intel_knowledge_center: 'Pusat Pengetahuan Cerdas ShareBot',
    sharebot_welcome_paragraph:
      'Selamat datang di Pusat Pengetahuan ShareBot, chatbot AI canggih yang dirancang untuk mengubah cara profesional mengakses informasi dan berkolaborasi.',
    expired: 'Kedaluwarsa',
    active: 'Aktif',
    Inactive: 'Tidak Aktif',
    yearly_subscription: 'Langganan Tahunan',
    monthly_subscription: 'Langganan Bulanan',
    no_sharebot_org: 'Anda tidak memiliki organisasi Sharebot',
    sharebot_start_free_trial: 'Mulai Uji Coba Gratis',
    sub_month: 'Langganan Bulanan',
    sub_year: 'Langganan Tahunan',
    question_per_month: 'Penyimpanan Data (1TB) dan 1000 Pertanyaan per Bulan',
    sharebot_para:
      'Dengan melanjutkan, Anda mengonfirmasi penghapusan organisasi secara permanen. Tindakan ini akan menyebabkan hilangnya semua wawasan berharga yang diberikan oleh ShareBot dan tidak dapat dibatalkan.',
    cancelled_date: 'Tanggal Dibatalkan:',
    live_straming_para:
      'Jika Anda ingin mengubah batas streaming langsung bulanan, silakan hubungi',
    sharelook_agree: 'Saya setuju dengan',
    terms_condition: 'syarat & ketentuan',
    and: 'dan',
    privacy_policy: 'kebijakan privasi',
    save_for_later: 'Simpan untuk Nanti',
    ai: 'AI',
    no_video_yet: 'Belum Ada Video yang Dipilih!',
    are_you_sure_delete_video: 'Apakah Anda yakin ingin menghapus video ini?',
    video_des: 'Deskripsi',
    video_now: 'Sekarang',
    video_playing: 'Sedang Diputar:',
    video_no: 'Video No.',
    ai_generated_course: 'Kursus Buatan AI',
    create_course_on_our_own: 'Buat Kursus Sendiri',
    ai_Assisted_ourse_reation: 'Pembuatan Kursus dengan Bantuan AI',
    pending: 'Menunggu',
    published: 'Diterbitkan',
    intro_course: 'ke dalam kursus Anda?',
    clone_course: 'Apakah Anda ingin menggandakan',
    browser_audio_not_support: 'Browser Anda tidak mendukung tag audio.',
    audio_popup_content:
      'Di sini Anda dapat menggunakan berbagai gaya suara untuk teks yang Anda ketik bla bla bla Lorem Ipsum hanyalah teks contoh dari industri percetakan dan penataan huruf. Lorem Ipsum telah menjadi standar teks contoh sejak tahun 1500-an.',
    close: 'Tutup',
    podcast_rec: 'REKAM',
    create_podcast: 'Buat Podcast',
    add_admin: 'TAMBAH ADMIN',
    delete_all: 'Hapus Semua',
    ai_podcast_audio: 'Audio Podcast AI',
    language: 'Bahasa',
    podcast_download_content:
      '*Unduh file Audio AI untuk diedit menjadi file audio Anda.',
    upload_audio: 'Unggah Audio',
    browser_do_not_support_audio: 'Browser Anda tidak mendukung elemen audio.',
    upload_cover: 'Unggah Sampul',
    upload_ai_creator: 'Pembuat AI',
    required_cover_image: 'Gambar Sampul wajib diisi!',
    room_required_name: 'Nama Podcast wajib diisi!',
    add_guest_list: 'Silakan tambahkan daftar tamu!',
    podcast_add_participants: 'TAMBAH PESERTA',
    topic_required: 'Minimal satu topik diperlukan',
    podcast_description: 'DESKRIPSI',
    podcast_date: 'TANGGAL',
    date: 'Tanggal',
    podcast_time: 'waktu',
    podcast_to: 'hingga',
    podcast_all_day: 'Sepanjang hari',
    podcast_start_date_time: 'Tanggal dan Waktu Mulai wajib diisi!',
    podcast_id: 'ID',
    selected_user: 'Undang Pengguna Terpilih',
    see_more: 'Lihat Lebih Banyak',
    see_less: 'Lihat Lebih Sedikit',
    no_review_yet: 'Belum ada ulasan, jadilah yang pertama.',
    request_to_speak: 'Terima permintaan pengguna untuk berbicara?',
    kick_user: 'Apakah Anda ingin mengeluarkan pengguna ini?',
    accept_request: 'Terima Permintaan',
    kick: 'KELUARKAN',
    started: 'DIMULAI',
    end: 'SELESAI',
    join_now: 'Bergabung Sekarang',
    podcast_end: 'Podcast telah berakhir',
    connecting: 'menghubungkan...',
    knowledge_center_know_today: 'Apa yang ingin Anda ketahui hari ini?',
    knowledge_center_question: 'Silakan masukkan pertanyaan terlebih dahulu',
    knowledge_center_error: 'Maaf! Kami mengalami kesalahan.',
    knowledge_center_tooltrip:
      'Dapatkan jawaban cepat dari sumber pembelajaran di repositori organisasi Anda di ShareLook, dengan referensi yang tepat dan kemungkinan untuk melihat serta mengunduh dokumen pdf yang dirujuk.',
    my_organization: 'Organisasi Saya',
    world_knowledge: 'Pengetahuan Dunia',
    open_file: 'Buka File',
    reference: 'Referensi',
    are_you_cancel: 'Apakah Anda yakin ingin membatalkan?',
    are_you_remove_media: 'Apakah Anda yakin ingin menghapus media?',
    terms_agree: 'Saya setuju dengan',
    ready: 'Siap',
    send_email: 'KIRIM EMAIL',
    active_users: 'Pengguna Aktif',
    sign_up_user: 'Pengguna Terdaftar',
    non_sign_up_user: 'Pengguna Tidak Terdaftar',
    organisation: 'Organisasi',
    usage_report: 'Laporan Penggunaan',
    check_email: 'periksa email Anda',
    delete_schedule: 'Hapus Jadwal',
    are_you_sure_delete_schedule:
      'Apakah Anda yakin ingin menghapus jadwal ini?',
    add_task: 'Silakan masukkan tugas!',
    coaching_available: 'Tandai sebagai Ketersediaan Coaching',
    message_booking_coaching:
      'Slot waktu ini telah dipesan oleh pengguna untuk coaching.',
    task_day: 'Hari Tugas',
    created_task_day: 'Anda telah membuat tugas untuk hari ini.',
    event_day: 'Hari Acara',
    has_booked_coaching: 'Coaching telah dipesan untuk hari ini.',
    active_day: 'Hari Aktif',
    selectable_time_slots:
      'Slot waktu yang dapat dipilih di kanan aktif untuk hari ini.',
    compare_last_month: 'Dibandingkan dengan Bulan Lalu',
    uploading_file: 'Mengunggah file Anda',
    attach_file_course: 'dilampirkan ke kursus ini.',
    fetch_request: 'Mengambil permintaan Anda',
    finilize_upload: 'Menyelesaikan unggahan',
    scorm_scanned: 'Tunggu sebentar... File SCORM zip Anda sedang dipindai.',
    scan_status: 'Status Pemindaian:',
    scan_completed: 'Pemindaian Selesai. File Anda',
    scan_progress: 'Pemindaian sedang berlangsung...',
    check_scorm: 'Memeriksa format file SCORM Anda... Tunggu sebentar...',
    file_check_success: 'Pemeriksaan file berhasil',
    file_check_progress: 'Pemeriksaan file sedang berlangsung...',
    scorm_not_upload:
      'File yang diunggah bukan standar SCORM 1.2, silakan unggah ulang.',
    select_question: 'Opsi Jawaban (pilih satu jawaban benar)',
    select_answer: 'Silakan pilih opsi jawaban!',
    check_option_one: 'Silakan masukkan opsi satu!',
    check_option_two: 'Silakan masukkan opsi dua!',
    check_option_three: 'Silakan masukkan opsi tiga!',
    check_option_four: 'Silakan masukkan opsi empat!',
    question_image: 'Gambar Pertanyaan',
    select_question_image: 'Silakan pilih gambar pertanyaan!',
    ans_image: 'Gambar Jawaban',
    upload_image_question: 'Unggah Gambar Jawaban',
    select_image_answer: 'Silakan pilih gambar jawaban!',
    save_question: 'Simpan Pertanyaan',
    do_you_leave: 'Apakah Anda yakin ingin keluar?',
    loose_all_progress: 'Anda akan kehilangan semua kemajuan Anda.',
    welcome: 'Selamat Datang',
    team_knowledge_quest: 'Petualangan Pengetahuan Tim',
    your_score: 'Skor Anda',
    start_playing: 'Mulai Bermain',
    share_sphere_complete: 'ShareSphere Selesai',
    final_score: 'Skor Akhir',
    play_next: 'Mainkan Berikutnya',
    you_donot_access_event: 'Anda tidak memiliki akses ke acara ini.',
    ai_content_generated: 'Konten telah dibuat untuk topik ini.',
    ai_popup_confirm_content: 'Konfirmasi Pembuatan Konten'
  },
  v2: {
    n_data: 'Tidak Ada Data',
    change: 'Ubah',
    remove: 'Hapus',
    auto_background: 'Latar Otomatis',
    create_new_course_org: 'Buat kursus baru untuk organisasi Anda.',
    create_new_course_marketplace: 'Buat kursus baru untuk marketplace.',
    create_new_course_both:
      'Buat kursus baru untuk organisasi Anda dan marketplace.',
    ok: 'Oke',
    page_bg: 'Latar Halaman',
    lesson_cover: 'Gambar Sampul Pelajaran',
    create_skill_journey: 'Buat Perjalanan Keterampilan',
    Metamaze: 'Metamaze',
    events: 'Acara',
    scroms: 'SCORM',
    min_score_pass: 'Skor Minimum untuk Lulus',
    no_scorms_available: 'Tidak ada SCORM yang tersedia.',
    no_events_available: 'Tidak ada acara yang tersedia.',
    no_courses_available: 'Tidak ada kursus yang tersedia.',
    no_courses_baskets: 'Tidak ada kursus di keranjang.',
    no_mazes_baskets: 'Tidak ada maze di keranjang.',
    no_scroms_baskets: 'Tidak ada SCORM di keranjang.',
    no_events_baskets: 'Tidak ada acara di keranjang.',
    sorry: 'Maaf!',
    option_1: 'Opsi 1',
    option_2: 'Opsi 2',
    enter_number_words: 'Masukkan jumlah maksimum kata.',
    summarize: 'Ringkas',
    answer: 'Jawab',
    hold_tight_one_minute:
      'Tahan dulu! Kami sedang menyiapkan. Ini bisa memakan waktu hingga satu menit.',
    enter_question: 'Masukkan pertanyaan Anda.',
    enter_relevant_documents: 'Masukkan jumlah dokumen relevan.',
    please_input_relevant_documents:
      'Harap masukkan jumlah dokumen yang relevan!',
    please_wait_loading_results: 'Harap tunggu hasil sedang dimuat...',
    proceed_to_add_voice: 'Lanjutkan untuk Menambahkan Suara',
    results: 'Hasil',
    no_result_found_try_asking_questions:
      'Tidak ada hasil. Coba ajukan lebih banyak pertanyaan.',
    eg: 'misalnya,',
    what_make_sales_manager:
      'Apa yang bisa membuat saya menjadi manajer penjualan?',
    please_select_lang: 'Harap pilih bahasa!',
    search: 'Cari',
    please_copy_desired_content:
      'Silakan salin konten yang diinginkan dari kotak kiri ke kotak kanan.',
    rating_req: 'Peringkat adalah bidang wajib.',
    review_req: 'Ulasan adalah bidang wajib.',
    rating_review_req: 'Harus memberikan peringkat dan ulasan.',
    how_rate_this: 'Seberapa Anda Akan Menilai Ini?',
    amazing_above_expectations: 'Luar biasa! Melebihi harapan!',
    certificates: 'Sertifikat',
    you_no_certificates: 'Anda tidak memiliki sertifikat saat ini.',
    please_add_review:
      'Harap berikan ulasan bersama dengan peringkat, Terima kasih!',
    post: 'Kirim',
    rate: 'Nilai',
    avg_rating: 'Rata-rata Peringkat',
    no_review_found: 'Tidak Ditemukan Ulasan',
    are_sure_to_disale_zoom_integration:
      'Apakah Anda yakin ingin menonaktifkan integrasi Zoom?',
    badges: 'Lencana',
    you_no_badge_available: 'Anda tidak memiliki lencana saat ini.',
    download_certificate: 'Unduh Sertifikat',
    loading: 'Memuat...',
    no_file_attached: 'Tidak ada file yang terlampir',
    you_do_not_have_any_notes: 'Anda tidak memiliki catatan apa pun.',
    question: 'Pertanyaan',
    score: 'Skor',
    alert_score_message: 'Orang telah menyerahkan skor mereka.',
    alert_question_message: 'Belum ada pertanyaan ditambahkan.',
    button_submit: 'Kirim',
    button_allScores: 'Semua skor telah dikirim.',
    record_wait: 'Perekaman akan dimulai. Harap tunggu...',
    buttonSubmit_warning: 'Harap masukkan semua skor sebelum mengirim.',
    upload_ar_assets: 'Unggah Aset AR',
    edit_ar_assets: 'Edit Aset AR',
    edit_maze_assets: 'Edit Aset MetaMaze',
    upload_assets: 'Unggah Aset',
    upload_maze_assets: 'Unggah Aset MetaMaze',
    trigger_title: 'Judul Pemicu',
    model_title: 'Judul Model',
    trigger_description: 'Deskripsi Pemicu',
    model_description: 'Deskripsi Model',
    please_type_target_description: 'Silakan ketik deskripsi target.',
    please_type_model_description: 'Silakan ketik deskripsi model.',
    trigger_image: 'Gambar Pemicu*',
    model_image: 'Gambar Model*',
    upload_trigger_image: 'Unggah Gambar Pemicu',
    upload_model_image: 'Unggah Gambar Model',
    drag_n_drop: 'Seret dan Lepaskan',
    file_size_should_not_exceed:
      '(Ukuran File Gambar (JPEG) tidak boleh melebihi 512 KB)',
    zip_size_should_not_exceed: '(Ukuran File Zip tidak boleh melebihi 60 MB)',
    ar_content: 'Konten AR*',
    model_content: 'Model 3D*',
    upload_3d_zip: 'Unggah ZIP / Video',
    upload_3d_maze_zip: 'Unggah ZIP',
    audio_content: 'Konten Audio',
    _mp3: '(.mp3)',
    content_attached: 'Zip Terlampir.',
    video_attached: 'Video Terlampir.',
    audio_attached: 'Audio Terlampir.',
    enter_trigger_image_title: 'Masukkan judul gambar pemicu.',
    enter_model_title: 'Masukkan judul model MetaMaze.',
    ar_preview_image: 'Gambar Pratinjau AR',
    upload_preview_image: 'Unggah Gambar Pratinjau',
    upload_audio: 'Unggah Audio',
    creating___: 'Membuat...',
    updating___: 'Memperbarui...',
    create: 'Buat',
    update: 'Perbarui',
    ar_assets: 'Gambar 3D',
    _3d_files_mp4: '(File .obj, .fbx atau Video .mp4 yang dikompres)',
    _3d_files_mp4_ar: '(File .obj, .fbx yang dikompres)',
    maze_3d_files_mp4: '(File .obj, .fbx yang dikompres)',
    _jpg_files: 'Hanya mendukung .jpg',
    persons_have_submitted_their_scores: 'Orang telah mengirimkan skor mereka.',
    no_questions_added_till_now: 'Belum ada pertanyaan yang ditambahkan.',
    submit: 'Kirim',
    all_scores_submitted: 'Semua skor telah dikirim.',
    recording_is_starting: 'Perekaman akan dimulai. Harap tunggu...',
    please_input_scores_before_submitting:
      'Harap masukkan semua skor sebelum mengirim.',
    end_for_all: 'Akhiri untuk Semua',
    full_screen: 'Layar Penuh',
    breakout_room: 'Ruang Terpisah',
    send_invitations: 'Kirim Undangan',
    add_participants: 'Tambahkan Peserta',
    create_breakout_room: 'Buat Ruang Terpisah',
    connecting: 'Menghubungkan...',
    currently_broadcaster_unavailable: 'Saat ini, penyiar tidak tersedia.',
    how_many_breakout_room_to_create:
      'Berapa banyak ruang terpisah yang ingin Anda buat?',
    create_upto_three_breakout_rooms: '*Buat hingga 3 Ruang Terpisah',
    allow: 'Izinkan',
    additional: 'Tambahan',
    attachment: 'Lampiran',
    no_description_available: 'Tidak ada deskripsi tersedia.',
    people: 'ORANG',
    waiting: 'Menunggu',
    hand_raising_users: 'Pengguna yang Mengangkat Tangan',
    invite: 'Undang',
    create_room: 'Buat Ruangan',
    create_live_event: 'Buat Acara Langsung',
    support_upto_fivethousand_participants:
      'Mendukung hingga 5.000 peserta untuk acara',
    support_upto_ten_participants: 'Mendukung hingga 10 peserta video langsung',
    support_upto_twohundred_participants:
      'Mendukung hingga 200 peserta untuk acara',
    supprt_upto_five_participants: 'Mendukung hingga 5 peserta video langsung',
    support_upto_twentyfive_participants:
      'Mendukung hingga 25 peserta video langsung untuk acara',
    two_live_video_participants:
      'Terdapat 2 peserta video langsung untuk acara (host dan peserta)',
    you_can_have_upto_five_examinees:
      'Anda hanya dapat memiliki hingga 5 peserta ujian.',
    you_can_have_upto_twentyfive_participants:
      'Anda hanya dapat memiliki hingga 25 peserta.',
    you_can_have_upto_five_participants:
      'Anda hanya dapat memiliki hingga 5 peserta.',
    you_can_have_upto_ten_participants:
      'Anda hanya dapat memiliki hingga 10 peserta.',
    select_hosts_email: 'Pilih Email Host',
    send_invite_email: 'Kirim Email Undangan',
    do_not_send_invite_email: 'Jangan Kirim Email Undangan',
    error: 'Kesalahan',
    max_twentyfive_users_allowed: 'Maks. 25 pengguna dapat dipilih',
    max_five_users_allowed: 'Maks. 5 pengguna dapat dipilih',
    max_ten_users_allowed: 'Maks. 10 pengguna dapat dipilih',
    no_user_found: 'Tidak Ada Pengguna Ditemukan',
    transcribe_to: 'Transkripsi ke',
    integrate_zoom_to_start_meeting:
      'Integrasikan Zoom ke akun Anda untuk memulai rapat Zoom.',
    zoom_is_not_integrated: 'Zoom belum diintegrasikan.',
    delete_poll: 'Hapus Jajak Pendapat',
    add_poll: 'Tambahkan Jajak Pendapat',
    live_now: 'SIARAN LANGSUNG!',
    average_rating: 'Peringkat Rata-rata',
    review: 'Ulasan',
    time_spent: 'Waktu Dihabiskan',
    total: 'Total',
    mins: 'Menit',
    no_data: 'Tidak ada data untuk kuis ini.',
    total_score: 'Skor Total',
    pass_score: 'Skor Lulus',
    point: 'Poin',
    wrong: 'Salah',
    response: 'Respons',
    submitted: 'Dikirim',
    average: 'Rata-rata',
    total_play: 'Total Putaran',
    view_graph: 'Lihat Grafik',
    time_spent_mins: 'Waktu Dihabiskan (Menit)',
    play: 'Putar',
    ideal_path: 'Jalur Ideal',
    user_incorrect_path: 'Jalur Tidak Tepat Pengguna',
    ideal_path_taken: 'Jalur Ideal yang Diambil oleh Pengguna',
    scenario: 'Skenario',
    option: 'Opsi',
    spend: 'Waktu',
    average_spending_time: 'Rata-rata Waktu Pengeluaran',
    activity_overview: 'Tinjauan Aktivitas',
    live_event: 'Acara Langsung',
    live_assessment: 'Penilaian Langsung',
    report_download: 'Unduh Laporan',
    all_workshops: 'Semua Lokakarya',
    overview_average_activity: 'Tinjauan Aktivitas Rata-rata',
    overview_workshop_graph: 'Tinjauan Grafik Lokakarya',
    mazes: 'Maze',
    correct_feedback: 'Umpan Balik Benar',
    incorrect_feedback: 'Umpan Balik Salah',
    checkin_checkout: 'Check-In - Check-Out',
    minutes: 'Menit',
    incorrect_path: 'Jalur Salah',
    answer_not_available: 'Jawaban Tidak Tersedia',
    views: 'Tampilan',
    item: 'Item',
    questions: 'Pertanyaan',
    total_points: 'Total Poin',
    total_attempts: 'Total Percobaan',
    created_date: 'Tanggal Dibuat',
    host_name: 'Nama Host',
    host_section: 'Bagian Host',
    choose_products: 'Pilih Produk',
    add_to_basket: 'Tambahkan ke Keranjang',
    basket: 'Keranjang',
    times: 'Kali',
    scorms: 'SCORM',
    skill_journey_overview: 'Tinjauan Perjalanan Keterampilan',
    how_to_use: 'Cara Menggunakan',
    live_broadcast_description:
      'KAMI TELAH MENGINTEGRASIKAN VIDEO LANGSUNG KE DALAM PEMBANGUN KURSUS YANG MUDAH DIGUNAKAN',
    live_broadcast_subdescription:
      'Dengan sistem siaran langsung paten ShareLook, Anda dapat menciptakan keterlibatan, mengotomatisasi pembelajaran, dan memaksimalkan berbagi pengetahuan.',
    disclaimer: `Saya menjamin bahwa perjalanan keterampilan saya tidak akan:
- melanggar hak pihak ketiga mana pun
- mengandung konten ilegal, termasuk yang memfitnah, cabul, tidak senonoh, mesum, pornografi, kekerasan, kasar, menghina, mengancam, atau diskriminatif, bahkan jika disamarkan dengan tanda bintang
- mengandung serangan pribadi terhadap individu lain
- menyamar sebagai peserta lain, tokoh publik atau selebritas
- berisi rekaman atau informasi pribadi siapa pun tanpa izin orang tersebut dan tidak melanggar peraturan perlindungan data di mana pun di dunia
- mengandung ajakan komersial atau bentuk "spam" apa pun`,
    price: 'Harga',
    video_link: 'Tautan Video',
    category: 'Kategori',
    objectives: 'Tujuan',
    marketplace_description: 'Deskripsi Marketplace',

    live_discussion: 'DISKUSI LANGSUNG',
    poll: 'JAJAK PENDAPAT',
    hide_grid: 'Sembunyikan Grid',
    show_grid: 'Tampilkan Grid',
    stop_screen_share: 'Hentikan Berbagi Layar',
    screen_share: 'Berbagi Layar',
    mute: 'Bisukan',
    unmute: 'Bunyikan',
    raise_hand: 'Angkat Tangan',
    waiting__: 'Menunggu...',
    audio_active: 'Audio Aktif'
  },
  general: {
    save: 'simpan',
    autosaved: 'simpan otomatis',
    back_to: 'kembali ke',
    by: 'oleh',
    chat: 'percakapan',
    completed: 'selesai',
    canceled: 'Dibatalkan',
    component: 'Komponen',
    confirm: 'Konfirmasi',
    course: 'Perkuliahan',
    skill: 'Perjalanan Keterampilan',
    maze: 'MetaMaze',
    channel: 'Saluran',
    podcast: 'Podcast',
    date: 'Tanggal',
    details: 'Detail',
    empty: 'Tidak ada data',
    enrolled: 'Mengikuti',
    free: 'Gratis',
    graph: 'Grafik',
    loading: 'Memuat...',
    lesson: 'Pelajaran',
    lessons: 'Pelajaran',
    live_assessment: 'Ujian langsung',
    live_event: 'Acara langsung',
    no: 'Tidak',
    of: 'Dari',
    or: 'Atau',
    organization: 'Organisasi',
    page: 'Halaman',
    pages: 'Halaman',
    personal: 'Pribadi',
    poll: 'Poling',
    rating: 'Penilaian',
    reset: 'Setel Ulang',
    signin: 'Masuk',
    signup: 'Daftar',
    soon: 'Segera',
    type: 'Ketik',
    uploading: 'Mengunggah...',
    yes: 'Ya',
    something_went_wrong: 'Terjadi kesalahan!',
    view_all: 'Lihat semua',
    upload_successful: 'Berhasil mengunggah',
    upload_successful_message:
      'Dokumen excel anda berhasil diunggah dan sedang diproses. Hal ini akan membutuhkan beberapa waktu. ',
    check_email_upload_successful:
      'Harap <0>periksa email anda</0> perihal <1>laporan</1> daftar pengguna yang telah diunggah.',
    is_private: 'Pribadi'
  },

  account: {
    title: 'Akun',
    subtitle: 'Kelola pengaturan dan informasi akun anda.',
    saved: 'Akun berhasil dirubah'
  },

  assessments: {
    title: 'Ujian',
    subtitle: 'Buat sebuah ujian',
    finished: 'Ujian telah berakhir',
    countdown: 'Ujian langsung akan disiarkan dalam ',
    create: 'Buat ujian',
    list_title: 'Ujian anda',
    delete_warning: 'Apakah anda yakin akan menghapus item ini?',
    details_title: 'Tambahkan Detail Ujian',
    details_subtitle:
      ' Beri Nama Ujian Anda dan informasikan kepada pemirsa hal yang akan dipelajari dari ujian ini.',
    disclaimer: `Saya menjamin ujian yang saya rekam tidak akan:
    - melanggar hak pihak ketiga
    - mengandung hal ilegal, termasuk umpatan, hal cabul, hal tidak senonoh, kemesuman, pornografi, kekerasan, penghinaan, cemoohan, ancaman, or diskriminasi, bahkan jika disamarkan dengan asterik
    - mengandung serangan pribadi terhadap pihak lain
    - mengandung peniruan terhadap peserta yang lain, publik figur maupun selebriti
    - mengandung rekaman maupun informasi pribadi individu tertentu tanpa disertai persetujuan pihak terkait dan bukan pelanggaran regulasi perlindungan data dimanapun di seluruh dunia
    - mengandung maksud komersil maupun segala bentuk "spam"'`,
    assessment_details: 'Detail Ujian',

    assessment_settings: 'Pengaturan Ujian'
  },

  buildersettings: {
    title: 'Pengaturan Publikasi',
    subtitle:
      'Tambahkan pengaturan acara anda, siapa yang dapat menyaksikan dan berinteraksi dalam acara anda'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Tambah',
    add_page: 'Tambah halaman',
    add_lesson: 'Tambah pelajaran',
    add_answer: 'Tambahkan jawaban baru',
    add_group: 'Tambah Grup',
    add_organization: 'Tambah Organisasi',
    add_question: 'Tambah pertanyaan',
    add_quiz: 'Tambah kuis',
    add_users: 'Tambah pengguna',
    back: 'Kembali',
    back_to_course: 'Kembali ke ringkasan perkuliahan',
    back_to_lesson: 'Kembali ke ringkasan pelajaran',
    back_to_media: 'Kembali ke Pustaka Media',
    back_to_details: 'Kembali ke detail',
    cancel: 'Batal',
    clear: 'Bersihkan',
    close: 'Tutup',
    clone: 'Gandakan',
    close_lesson: 'Tutup Pelajaran',
    clone_course: 'Tutup Perkuliahan',
    confirm: 'Konfirmasi',
    create: 'Buat',
    download: 'Unduh',
    download_mass_user_tamplate: 'Unduh Format',
    add_mass_users: 'Tambah Pengguna Masal',
    upload_excel_list: 'Unggah Daftar Excel',
    delete: 'Hapus Media',
    edit: 'Edit',
    edit_course: 'Edit Perkuliahan',
    enroll: 'Ikuti',
    finish: 'Selesai',
    upload_image: 'Unggah gambar',
    upload_image_video: 'Unggah gambar atau video',
    select_media_library: 'Pilih pustaka media',
    make_public: 'Jadikan untuk Publik',
    make_private: 'Jadikan untuk Pribadi',
    make_org: 'Jadikan untuk Organisasi',
    media: 'Pustaka Media',
    my_theme: 'Temaku',
    next: 'Selanjutnya',
    next_lesson: 'Pelajaran Selanjutnya',
    next_step: 'Langkah selanjutnya',
    previous_step: 'Langkah sebelumnya',
    publish: 'Publikasikan',
    publish_assessment: 'Publikasikan ujian anda',
    publish_course: 'Publikasikan perkuliahan anda',
    publish_event: 'Publikasikan acara anda',
    reset: 'Setel ulang',
    reset_elements: 'Setel ulang elemen',
    save: 'Simpan',
    creating: 'Membuat...',
    updating: 'Memperbaharui...',
    saved: 'Tersimpan',
    save_for_later: 'Simpan untuk nanti',
    save_settings: 'Simpan pengaturan',
    select_files: 'Pilih file',
    select_theme: 'Pilih tema',
    start_lesson: 'Mulai Pelajaran',
    update: 'Perbaharui',
    upload: 'Unggah',
    upload_audio: 'Unggah Audio',
    upload_photo: 'Unggah foto profil',
    upload_video: 'Unggah Video',
    enrolled: 'Mengikuti',
    unenroll: 'Batal Mengikuti',
    from_library: 'Pustaka Media',
    remove: 'Hapus',
    removed: 'Telah dihapus',
    start_broadcast: 'Mulai Siaran',
    end_broadcast: 'Akhiri Siaran',
    camera: 'Kamera',
    screen: 'Layar',
    screen_with_camera: 'Layar dengan Kamera',
    insert: 'Sisipkan',

    inserting: 'Menyisipkan'
  },
  card: {
    quick_add: 'Tambahan cepat',
    add: 'Tambah',
    clone: 'Gandakan',
    completed: 'Pelajaran telah selesai'
  },

  course: {
    upcoming_course: 'Perkuliahan Berikutnya',
    unPublishEvent: 'Acara yang belum dipublikasikan',
    unPublishAssessment: 'Ujian yang belum dipublikasikan',
    pastCourse: 'Pelatihan',
    upcoming: 'Acara langsung berikutnya',
    pastEvent: 'Acara langsung sebelumnya',
    pastAssessment: 'Ujian langsung sebelumnya',
    upcomingAssessment: 'Ujian langsung berikutnya',
    created: 'Tanggal Dibuat:',
    assignees: 'Petugas',
    organisations:
      ' {{ organisasi }} Organisasi, <2> {{ pengguna }} pengguna</2>',
    event_date: 'Tanggal acara langsung <1> {{ tanggal }} </1>',
    delete_warning: 'Apakah anda yakin akan menghapusnya',
    clonning_no_lesson:
      'Harap tambahkan setidaknya satu pelajaran jika hendak menggandakan perkuliahan ini.',
    clone_warning: 'Apakah anda yakin akan menggandakannya',
    clone_success: 'dalam proses penggandaan',
    disclaimer: `Saya menjamin perkuliahan saya tidak:
    - melanggar hak pihak ketiga
    - mengandung hal ilegal, termasuk umpatan, hal cabul, hal tidak senonoh, kemesuman, pornografi, kekerasan, penghinaan, cemoohan, ancaman, or diskriminasi, bahkan jika disamarkan dengan asterik
    - mengandung serangan pribadi terhadap pihak lain
    - mengandung peniruan terhadap peserta yang lain, publik figur maupun selebriti
    - mengandung rekaman maupun informasi pribadi individu tertentu tanpa disertai persetujuan pihak terkait dan bukan pelanggaran regulasi perlindungan data dimanapun di seluruh dunia
    - mengandung maksud komersil maupun segala bentuk "spam"'`
  },

  coursecreate: {
    dropzone_text: 'Sisipkan media',
    sidebar_text: 'Pilih tema <1/> untuk <3/> pelajaran anda',
    delete_warning: 'Apakah anda yakin akan menghapus pelajaran ini?'
  },

  coursepage: {
    quizview_loading: 'Memeriksa jawaban. Harap menunggu...',
    quizview_answer: 'Jawaban Anda'
  },

  coursequiz: {
    title: 'Kuis di setiap Pelajaran'
  },

  dashboard: {
    tooltip_title: 'Jangan tampilkan video ini lagi',
    page_title: 'Statistik Perkuliahan Anda',
    page_subtitle: 'Status perkuliahan yang anda buat',
    profile_add_info:
      'Tambahkan <1>{{uncompletedText}}</1> anda untuk melengkapi profil anda.',
    profile_build:
      'Buat profil anda <1>here</1>, beritahu kami minat dan ketrampilan anda.',
    profile_title: 'Kekuatan Profil',
    more_details: 'Lebih Banyak Detail'
  },

  errors: {
    answer: 'Harap masukkan jawaban',
    answer_correct: 'Pilih jawaban yang benar',
    code: 'Harap masukkan kode anda',
    criterion: 'Harap masukkan kriteria',
    duration: 'Durasi harus diisi',
    element: 'Harap masukkan elemen',
    email: 'Harap masukkan email anda',
    email_invalid: 'Anda memasukkan email yang tidak valid',
    feedback_correct: 'Harap masukkan umpan balik jika benar',
    feedback_incorrect: 'Harap masukkan umpan balik jika salah',
    host: 'Harap masukkan pembawa acara',
    host_assessment: 'Harap masukkan pembawa acara ujian',
    image: 'Harap unggah sebuah gambar',
    location: 'Harap masukkan lokasi anda',
    live_location: 'Harap pilih sebuah lokasi siaran',
    limit: 'Harap masukkan menit lamanya siaran langsung',
    min_3char: 'Minimal 3 karakter',
    number: 'Harap masukkan angka positif.',
    host_email_require: `Email pembawa acara harus diisi.`,
    attendee_email_require: `Email peserta harus diisi.`,
    name: 'Harap masukkan nama anda',
    not_found_course: 'Perkuliahan tidak ditemukan',
    not_found_event: 'Acara tidak ditemukan',
    not_found_assessment: 'Ujian tidak ditemukan',
    password: 'Harap masukkan kata sandi anda',
    password_digit: 'Gunakan setidaknya satu angka',
    password_short: 'Kata sandi terlalu pendek, minimal 10 karakter',
    password_special: 'At least one special character',
    password_uppercase: 'Gunakan setidaknya satu huruf besar',
    password_lowercase: 'Gunakan setidaknya satu huruf kecil',
    phone: 'Harap masukkan nomer telepon anda',
    phone_invalid: 'Nomer telepon tidak valid',
    position: 'Harap masukkan jabatan anda',
    question: 'Harap masukkan pertanyaan',
    start_date: 'Tanggal dan waktu mulai harus diisi',
    tag: 'Harap pilih sebuah penanda',
    topics: 'Harap pilih setidaknya satu topik.',
    live_topics: 'Harap tambahkan topik',
    title: 'Harap masukkan judul',
    title_assessment: 'Harap masukkan judul ujian',
    title_course: 'Harap masukkan judul perkuliahan',
    title_empty: 'Judul tidak boleh dikosongkan',
    title_event: 'Harap masukkan judul acara',
    title_lesson: 'Harap masukkan judul pelajaran',
    title_quiz: 'Harap masukkan nama kuis',
    username: 'Harap masukkan nama pengguna anda',
    invalid_verification_code: 'Tautan verifikasi ini telah kedaluwarsa atau tidak lagi valid. Hal ini biasanya terjadi jika email verifikasi yang lebih baru telah diminta. Silakan periksa email terbaru dari Sharelook untuk memverifikasi email Anda.',
    upload_error: 'Kesalahan – File tidak kompatibel!',
    upload_more_than_10: 'Maksimal 10 file sekali unggah.',
    topics_max: 'Harap tambahkan maksimal 3 topik.',
    upload_excel: 'Harap pastikan anda mengunggah file yang benar.',
    title_excel: 'Kesalahan mengunggah format:',
    file_size_exceed: 'Ukuran file terlalu besar',
    subtitle_excel:
      'Harap pastikan anda menggunakan format yang disediakan dan kolom diisi dengan benar.',
    select_broadcast_option:
      'Harap pilih sebuah opsi untuk menyiarkan acara ini',
    multi_hosts_number_error:
      'Jumlah penyaji tidak boleh melebihi yang telah ditentukan untuk acara.',
    conference_people_number_error: `Jumlah peserta tidak boleh melebihi yang telah ditentukan untuk acara.`,
    select_max_host: 'Pilih setidaknya 1 penyaji untuk acara.',
    select_max_conference: 'Pilih setidaknya 1 peserta untuk acara.',
    stream_stop_error: 'Siaran tiba-tiba berhenti!',
    unsecure_context:
      'Kesalahan Fatal: Peramban tidak dapat mengakses kamera dan mikropon disebabkan konteks yang tidak aman. Harap pasang SSL dan akses melalui https',
    ws_not_supported:
      'Kesalahan Fatal: WebSocket tidak didukung oleh peramban ini',
    no_org: 'Pilih setidaknya 1 organisasi untuk melanjutkan.',
    no_org_group: 'Pilih setidaknya 1 grup organisasi untuk melanjutkan.',
    waiting_to_join: 'Menunggu seseorang untuk bergabung!'
  },

  events: {
    title: 'Tambahkan Detail Acara Langsung',
    change_host: 'Ganti Pembawa Acara',
    finished: 'Acara telah berakhir',
    countdown: 'Acara Langsung akan disiarkan dalam ',
    subtitle:
      'Beri nama Acara Langsung anda dan informasikan kepada pemirsa hal yang akan dipelajari dari acara ini.',
    poll_disabled: 'Poling tidak tersedia dalam acara ini',
    disclaimer: `Saya menjamin bahwa rekaman acara saya tidak akan:
- melanggar hak pihak ketiga
    - mengandung hal ilegal, termasuk umpatan, hal cabul, hal tidak senonoh, kemesuman, pornografi, kekerasan, penghinaan, cemoohan, ancaman, or diskriminasi, bahkan jika disamarkan dengan asterik
    - mengandung serangan pribadi terhadap pihak lain
    - mengandung peniruan terhadap peserta yang lain, publik figur maupun selebriti
    - mengandung rekaman maupun informasi pribadi individu tertentu tanpa disertai persetujuan pihak terkait dan bukan pelanggaran regulasi perlindungan data dimanapun di seluruh dunia
    - mengandung maksud komersil maupun segala bentuk "spam"'`,
    prompt_message:
      'Meninggalkan halaman ini akan menyelesaikan acara anda, Apakah anda yakin? ',
    duration_exceed_message:
      'Siaran anda melebihi waktu yang ditentukan, aplikasi akan menghentikan siaran.',
    before_schedule_message:
      'Anda akan memulai siaran sebelum waktu yang dijadwalkan, harap diperhatikan bahwa menghentikan siaran akan mengakhiri acara.',
    browser_unsupportive_message:
      'Peramban anda tidak mendukung screen share. Anda dapat melihat peramban yang mendukung di sini',
    cancel_switch_host_message:
      'Pembawa acara tidak tersedia. Acara akan dilanjutkan dari sisi anda.',
    coaching_prompt_message:
      'Anda tidak dapat meninggalkan halaman ini sampai acara berakhir.',
    event_modal_warn: 'Apakah anda ingin meninggalkan acara ini?',
    confirm_message: 'Acara anda akan berakhir jika anda memilih OK.',
    screen_share_denied: 'Anda menolak untuk membagikan layar anda',
    media_not_found:
      'Kamera dan Mikropon tidak ditemukan atau tidak diijinkan di alat yang anda gunakan.',
    media_not_access:
      'Kamera atau Mikropon sedang digunakan oleh proses lain yang tidak mengijinkan aplikasi untuk membacanya',
    constraint_error:
      'Komponen sesuai batasan audio dan video yang anda tentukan tidak ditemukan. Harap merubah batasan audio dan video',
    media_access_denied: 'Anda tidak diijinkan mengakses kamera dan mikropon.'
  },

  filters: {
    days7: '7 hari terakhir',
    days15: '15 hari terakhir',
    days30: '30 hari terakhir',
    days365: '365 hari terakhir',
    date: 'Tanggal dibuat',
    relevance: 'Relevansi',
    popularity: 'Popularitas',
    name: 'Nama',
    group: 'Grup',
    Newest_to_Oldest: 'Dari yang Terbaru',
    Oldest_to_Newest: 'Dari yang Terlama',
    A_Z: 'A ke Z',
    Z_A: 'Z ke A'
  },

  helpers: {
    password:
      'Demi memastikan keamanan akun anda, kami mengharuskan penggunaan setidaknya satu huruf kecil dan angka dalam kata sandi anda, dengan panjang minimal 10 karakter.',
    phone: 'Harap sertakan kode telepon negara anda, contoh: +65',
    username:
      'Nama pengguna anda diberlakukan sebagai informasi publik dan akan dibagikan kepada pengguna lain sesuai kebutuhan. Oleh sebab itu maka kami menyarankan anda untuk tidak menggunakan data pribadi dalam nama pengguna anda',
    public_description_normal:
      ' <0><0/></0> anda telah disimpan dan dikategorikan Pribadi secara default. Hal ini berarti hanya anda yang dapat melihat isinya. Untuk mempublikasikannya anda dapat memilih salah satu opsi dibawah. Dengan mempublikasikan perkuliahan anda berarti ini akan tersedia bagi semua pengguna di platform. Opsi pengguna tertentu akan memperbolehkan anda membagikan perkuliahan anda hanya kepada pengguna tertentu menggunakan alamat email yang didaftarkan dalam akun Sharelooknya.',
    public_description_admin:
      ' <0><0/></0> telah disimpan dan dikategorikan Pribadi secara default. Hal ini berarti hanya anda (dan pembuatnya) yang dapat melihat isinya. Untuk mempublikasikannya anda dapat memilih salah satu opsi dibawah. Dengan mempublikasikan perkuliahan anda berarti ini akan tersedia bagi semua pengguna di platform – termasuk bagi pengguna di luar organisasi anda. Mempublikasikannya bagi organisasi berarti pengguna dalam organisasi dapat melihatnya. Anda juga dapat mempublikasikannya bagi 1 grup atau lebih yang berarti hanya anggota grup tersebut yang dapat melihatnya. Terakhir anda dapat memilih untuk mempublikasikannya kepada pengguna tertentu di dalam dan di luar organisasi anda dengan menggunakan alamat email akun Sharelooknya. '
  },

  labels: {
    add: 'Tambah',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Tipe Jawaban',
    answers: 'Jawaban',
    back_to_quiz: 'Kembali ke daftar kuis',
    back_to_question: 'Kembali ke daftar pertanyaan',
    chat: 'Percakapan',
    chat_available: 'Percakapan tidak tersedia dalam acara ini',
    chat_report: 'Laporan Percakapan',
    choice_single: 'Pilihan Tunggal',
    choice_multiple: 'Pilihan Ganda',
    choice_free: 'Pilihan "Bebas"',
    choice_sorting: 'Pilihan "Urutan"',
    choice_matrix: 'Pilihan "Urutan Matriks"',
    clone_lesson_permission: 'Ijin Penggandaan',
    code: 'Kode',
    correct: 'Benar',
    created: 'Tanggal dibuat',
    clone_modal: 'Gandakan Perkuliahan',
    cloning_course: 'Perkuliahan... sedang digandakan',
    cloning: 'Menggandakan...',
    cloning_course_desc: 'Proses ini membutuhkan waktu. Harap bersabar',
    cloning_success: 'Perkuliahan "<0/>" berhasil digandakan!',
    description: 'Deskripsi',
    disclaimer: 'Sangkalan',
    drop_file: 'Taruh file di sini...',
    duration: 'Durasi',
    edit: 'Edit',
    email: 'Email',
    event: 'Acara',
    event_all: 'Semua Acara',
    event_date: 'Tanggal/Waktu Lokal Acara Langsung',
    event_this: 'Acara ini',
    expire: 'Berakhir dalam',
    expiry_date: 'Tanggal Berakhir',
    forgot: 'Lupa kata sandi?',
    group: 'Grup',
    groups_list: 'Daftar Grup',
    host: 'Pembawa Acara',
    id_annotation: 'id Keterangan',
    id_quiz: 'id Kuis',
    incorrect: 'Salah',
    interests: 'Minat',
    invited: 'Diundang',
    live_chat: 'Diskusi Langsung',
    live_stream_limit: 'menit Siaran Langsung',
    contact_text: 'Untuk merubah batas siaran langsung bulanan harap hubungi',
    contact_admin:
      '<0>Jika anda ingin merubah batas siaran langsung bulanan anda silahkan menghubungi </0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Menit siaran langsung tersisa: <0>{{ limit }}</0> menit <1/><2/> <3>Untuk merubah batas siaran langsung bulanan anda silahkan menghubungi </3> <4>admin@sharelook.com</4>',
    location: 'Lokasi',
    lessons: 'Pelajaran',
    location_broadcast: 'Lokasi server pembawa acara',
    location_broadcast_subtitle:
      'Tambahkan lokasi terdekat dengan lokasi pembawa acara untuk mengurangi jeda audiovisual',
    media_manager: 'Pengelola media',
    minutes: 'Menit',
    name: 'Nama',
    online_quiz: 'Kuis Daring',
    organiser: 'Pembuat',
    organization: 'Organisasi',
    overall_emotion: 'Keseluruhan Kesan:',
    organizations_list: 'Daftar Organisasi',
    password: 'Kata sandi',
    participants: 'Peserta',
    picture: 'Gambar (16:9)',
    phone: 'Telepon',
    photo: 'Foto',
    poll: 'Poll',
    position: 'Jabatan',
    processing: 'Memproses',
    privacy_settings: 'Pengaturan Privasi',
    question: 'Pertanyaan',
    quiz_create: 'Buat Kuis Baru',
    quiz_name: 'Nama Kuis',
    quiz_update: 'Perbaharui Kuis',
    select_organization: 'Pilih Organisasi',
    settings: 'Pengaturan',
    show: 'Tampilkan',
    show_graph: 'Tampilkan hasil Grafik',
    signin: 'Masuk',
    signup: 'Daftar',
    sort_by: 'Urut berdasarkan',
    start_date: 'Tanggal Mulai',
    tags: 'Penanda',
    terms: 'Saya menyetujui <1>syarat dan ketentuan</1> ini.',
    title: 'Judul',
    topics: 'Topik',
    topic: 'Topik',
    total_comments: 'Total Komentar',
    username: 'Nama Pengguna',
    users_list: 'Daftar Pengguna',
    users_emails: 'Sisipkan email pengguna tertentu',
    description_specifiction_email:
      ' Harap masukkan 1 alamat email per baris untuk membagikan dengan beberapa pengguna tertentu..',
    message_specific_email: 'Harap masukkan email pengguna tertentu.',
    viewers: 'Pemirsa',
    edit_course: 'Edit',
    edit_assessment: 'Edit',
    edit_event: 'Edit',
    delete_course: 'Hapus',
    delete_event: 'Hapus',
    delete_assessment: 'Hapus',
    view_course: 'Lihat',
    view_event: 'Lihat',
    view_assessment: 'Lihat',
    date_event: 'Tanggal Acara langsung',
    date_assessment: 'Tanggal Ujian langsung',
    clone_of: 'Gandakan',
    clone_course:
      'Buat salinan perkuliahan ini yang dapat anda modifikasi secara independen, termasuk pelajaran dan halamannya.',
    make: 'Buat',
    available_to: 'Tersedia bagi semua pengguna ShareLook',
    uploaded_by: 'Diunggah oleh: ',
    course: 'Perkuliahan',
    assessment: 'Ujian',
    user_not_exist:
      'Pengguna tidak ditemukan, apakah anda ingin mengirim undangan?',
    check_user: 'Perhatikan',
    user_not_exist_in_org:
      'Pengguna tidak ditemukan dalam organisasi ini, apakah anda ingin mengirim undangan?',
    title_modal_stream: 'Rubah Batas Siaran Langsung Organisasi',
    des_warning_stream: 'Anda akan merubah',
    monthly_stream: 'Batas waktu siaran langsung bulanan:',
    min_per_month: 'menit/bulan',
    broadcast_label: 'Saya ingin:',
    hosts_emails: `Sisipkan email pembawa acara tertentu `,
    attendee_emails: `Sisipkan email peserta tertentu `,
    description_host_specifiction_email:
      'Harap masukkan 1 alamat email per baris.',
    presenter_label: 'Penyaji',
    presenter_label_conference: 'Jumlah orang',
    event_privacy: 'Mode Konferensi'
  },

  broadcastOptions: {
    stream_from_phone: 'Siaran Langsung dengan menggunakan telepon saya',
    other_webrtc: 'Webinar dari komputer saya',
    multihost: 'Webinar Multicast dari komputer saya',
    peer2peer: 'Sesi Pelatihan',
    conference: 'Konferensi Langsung'
  },

  lessoncreate: {
    title: 'Tambahkan Detail Pelajaran',
    subtitle:
      ' Beri nama Pelajaran anda dan informasikan kepada pemirsa hal yang akan dipelajari dari acara ini.',
    input_label_title: 'Judul Pelajaran',
    input_label_topics: 'Topik Pelajaran',
    input_label_description: 'Deskripsi Pelajaran',
    delete_warning: 'Apakah anda yakin akan menghapus halaman ini?'
  },

  lessonoverview: {
    title: 'Tambah Pelajaran',
    subtitle: 'Tambah pelajaran yang sudah ada atau buat yang baru',
    new_lesson: 'Buat Pelajaran Baru',
    new_lesson_sub: 'Buat pelajaran baru dari awal!',
    existing_lesson: 'Pilih pelajaran yang sudah ada',
    existing_lesson_sub:
      'Hubungkan ke pelajaran yang sudah ada, merubah pelajaran ini akan merubah pelajaran yang sama di Perkuliahan lainnya.',
    clone_lesson: 'duplikasi pelajaran yang sudah ada',
    clone_lesson_sub:
      'Buat duplikasi unik dari pelajaran di perkuliahan ini, merubah  pelajaran ini tidak akan merubah pelajaran aslinya.',
    clone_lesson_modal_sub:
      'Klik tombol gandakan dibawah pelajaran yang ingin anda tambahkan ke perkuliahan.'
  },

  management: {
    groups_title: 'Kelola Grup',
    delete_warning: 'Apakah anda yakin?',
    organizations_title: 'Organisasi saya',
    organizations_subtitle: 'Tambahkan organisasi ke daftar anda',
    users_title: 'Kelola Pengguna',
    users_position: 'Senior Account Manager',
    user_not_found: 'Pengguna tidak ditemukan',
    select_org: 'Harap cari dan pilih organisasi untuk mengelola pengguna'
  },

  audio: {
    modal_title: 'Sisipkan Audio',
    list_view: 'Tampilan daftar',
    create_audio_modal_title: 'Buat Audio',
    edit_audio_modal_title: 'Edit Audio',
    public_audio_not_found: 'Audio tidak ditemukan.',
    private_audio_not_found: 'Anda belum mengunggah audio',
    are_you_sure_to_delete: 'Apakah anda yakin akan menghapus?',
    type_something: 'Ketik sesuatu',
    select_voice: 'Pilih',
    file_name: 'Nama File',
    description: 'Deskripsi',
    topic: 'Topik',
    key_words_tag: 'Kata Kunci Penanda',
    mp3_audio: 'Audio MP3',
    created: 'Dibuat',
    duration: 'Durasi',
    close: 'tutup'
  },

  image: {
    modal_title: 'Sisipkan Gambar',
    image: 'Gambar',
    pixel: 'Piksel',
    dimension: 'Ukuran',
    public_image_not_found: 'Gambar tidak ditemukan.',
    private_image_not_found: 'Anda belum mengunggah gambar'
  },

  annotation: {
    modal_title: 'Keterangan'
  },

  text: {
    modal_title: 'Editor Teks'
  },

  video: {
    modal_title: 'Sisipkan Video',
    image: 'Video',
    mp4_video: 'Video MP4',
    public_video_not_found: 'Video tidak ditemukan.',
    private_video_not_found: 'Anda belum mengunggah video'
  },

  media: {
    title: 'Pustaka Media',
    subtitle: 'Pustaka file anda',
    modal_title: 'Unggah media',
    delete_warning: 'Konfirmasi penghapusan',
    delete_message:
      'Media yang telah dihapus akan tetap muncul pada halaman media tersebut digunakan',
    dropzone_text: 'atau Seret dan Taruh',
    delete_success: 'Media berhasil dihapus',
    upload_file: 'Unggah file',
    drag_drop: ' atau Seret dan Taruh ',
    import_file: 'Impor file dari komputer anda',
    no_media: 'Anda belum mengunggah media',
    media_type: 'Tipe Media',
    video: 'Video',
    image: 'Gambar',
    audio: 'Audio',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Media tidak ditemukan.',
    of: 'dari',
    disclaimer: `Saya menjamin bahwa media saya tidak:
    - melanggar hak pihak ketiga
    - mengandung hal ilegal, termasuk umpatan, hal cabul, hal tidak senonoh, kemesuman, pornografi, kekerasan, penghinaan, cemoohan, ancaman, or diskriminasi, bahkan jika disamarkan dengan asterik
    - mengandung serangan pribadi terhadap pihak lain
    - mengandung peniruan terhadap peserta yang lain, publik figur maupun selebriti
    - mengandung rekaman maupun informasi pribadi individu tertentu tanpa disertai persetujuan pihak terkait dan bukan pelanggaran regulasi perlindungan data dimanapun di seluruh dunia
    - mengandung maksud komersil maupun segala bentuk "spam"`,
    my_media: 'Mediaku',
    public_library: 'Perpustakaan Publik',
    organization_library: 'Perpustakaan Organisasi',
    upload_from_computer: 'Unggah dari Komputer',
    create: 'Buat',
    all: 'Semua',
    male: 'Pria',
    female: 'Wanita',
    processing_audio: 'Memproses Audio',
    create_annotation: 'Beri Keterangan',
    popup_over_lesson_text:
      'Keterangan akan muncul di laman pelajaran setelah di klik',
    edit_detail: 'Hapus Detail',
    delete: 'Hapus',
    go_create_audio: 'Buat Audio',
    show_more_details: 'Tampilkan lebih banyak detail',
    show_less_details: 'Tampilkan lebih sedikit detail',
    drop_files: 'Taruh file dan kemana diunggah',
    or: 'Atau',
    import_files: 'Impor file dari komputer'
  },

  navigation: {
    account: 'Akun',
    assessments: 'Ujian',
    dashboard: 'Dasbor',
    groups: 'Pengelolaan Grup',
    logout: 'Keluar',
    organisations: 'Organisasi',
    organizations_users: 'Organisasi & Pengguna',
    reports: 'Laporan',
    schedule: 'Jadwal',
    nowLive: 'Siaran',
    training: 'Latihan',
    users: 'Pengguna',
    workshop: 'Ruang Kerjaku'
  },

  onboarding: {
    step1_title: 'Langkah 1 : Beritahukan Kami tentang Diri Anda',
    step1_subtitle:
      'Siapa nama anda? Anda berasal dari? Apa sebutan bagi pekerjaan anda?',
    step2_title: 'Langkah 2 : Pilih keterampilan yang dapat anda kembangkan',
    step2_subtitle:
      'Selanjutnya, beritahu kami apa yang ingin anda pahami lebih jauh. Mungkin sesuatu yang belum anda pelajari? Bidang studi yang baru? Apa yang dilakukan kekasih anda?'
  },

  pagebuilder: {
    title: 'Buat Pelajaran',
    subtitle:
      'Waktunya membuat konten bagi pemirsa untuk belajar dari anda, anda dapat menambahkan gambar, video maupun infografik',
    select_layout: 'Pilih tata letak halaman',
    template1: 'Kosong',
    template2: 'Judul & Sub judul',
    template3: 'Judul & Teks',
    template4: 'Judul, Media & Teks',
    template5: 'Judul & Media',
    template6: 'Judul & Kuis'
  },

  pageconstructor: {
    title: 'Buat dan Gandakan Pelajaran',
    subtitle:
      ' Waktunya membuat konten bagi pemirsa untuk belajar dari anda, anda dapat menambahkan gambar, video maupun infografik'
  },

  passwordreset: {
    success_coded:
      'Kami telah mengirimkan email berisi kode konfirmasi ke alamat email yang anda sediakan, harap salin kode tersebut ke dalam bidang di bawah untuk mengatur kata sandi yang baru.',
    success_changed:
      'Anda berhasil mengatur kata sandi yang baru. Silahkan masuk.'
  },

  placeholders: {
    search: 'Cari',
    answer: 'Jawab',
    chat: 'Katakan sesuatu...',
    code: 'Kode',
    criterion: 'Kriteria',
    date_event: 'Pilih tanggal & waktu',
    date_start: 'Tanggal Mulai',
    date_expire: 'Tanggal Berakhir',
    description: 'Deskripsi',
    elements: 'Urutkan elemen',
    email: 'Email',
    feedback_correct: 'Umpan Balik sesuai',
    feedback_incorrect: 'Umpan Balik tidak sesuai',
    host: 'Pembawa Acara',
    keywords: 'Cari Kata Kunci',
    lesson_description: 'Deskripsi Pelajaran',
    location: 'Lokasi',
    minutes: 'Menit',
    name: 'Nama',
    organiser: 'Pembuat',
    organization: 'Organisasi',
    password: 'Kata Sandi',
    phone: 'Telepon',
    photo: 'Foto',
    picture: 'Gambar',
    point: 'Poin',
    position: 'Jabatan',
    question: 'Pertanyaan',
    quiz: 'Nama Kuis',
    search_course: 'Cari berdasarkan Perkuliahan',
    search_media: 'Cari Media',
    search_name: 'Cari berdasarkan Nama',
    search_title: 'Cari berdasarkan Judul',
    search_training: 'Cari Latihan',
    settings: 'Pengaturan',
    tags: 'Penanda',
    title: 'Judul',
    topics: 'Topik',
    username: 'Nama Pengguna',
    keyword: 'Kata Kunci',
    max_500_characters: 'Maks 500 Karakter ',
    no_description: 'File ini tidak memiliki deskripsi',
    no_keyword: 'File ini tidak memiliki kata kunci',
    no_topics: 'File ini tidak memiliki set topik',
    feedback: 'Pesan',
    contact: 'Bantuan apa yang anda butuhkan?'
  },

  publishsettings: {
    title: 'Pengaturan Publikasi',
    event_subtitle:
      'Tambahkan pengaturan acara anda, siapa yang dapat menyaksikan dan berinteraksi dalam acara anda',
    assessment_subtitile:
      ' Beri nama Ujian anda dan informasikan kepada pemirsa hal yang akan dipelajari dari acara ini',
    course_subtitle:
      'Tambahkan pengaturan perkuliahan anda, siapa yang dapat menyaksikan dan berinteraksi dalam acara anda',
    disclaimer: `Sangkalan

1.	Pendaftaran

    Dengan mendaftar sebagai pengguna/membuat sebuah akun maka anda menyatakan setuju terhadap (Perjanjian Pengguna) kami dan mengakui telah membaca (Kebijakan Privasi) kami


2.	Membuat perkuliahan

Dengan menggunakan aplikasi kami dan membuat muatan perkuliahan di dalamnya, anda menyatakan setuju terhadap (Perjanjian Pengguna) dan mengakui telah membaca (Kebijakan Privasi) kami



3.	Membuat acara

Dengan menggunakan aplikasi kami dan membuat sebuah acara di dalamnya, anda menyatakan setuju terhadap (Perjanjian Pengguna) dan mengakui telah membaca (Kebijakan Privasi) kami


4.	Membuat ujian

Dengan menggunakan aplikasi kami dan membuat ujian di dalamnya, anda menyatakan setuju terhadap (Perjanjian Pengguna) dan mengakui telah membaca (Kebijakan Privasi) kami`,

    dates_validation_error: 'Kedua tanggal harus diisi.',
    course_dates_validation_error: 'Silakan masukkan tanggal mulai dan berakhirnya kursus ini.',
    emails_validation_error: 'Daftar Email tidak valid.',
    specific_email_validation_error: 'Hanya satu email yang diperbolehkan.',
    i_agree_to_these: 'Saya menyetujuinya ',
    terms_and_conditions: 'syarat dan ketentuan.',
    PublicDescription:
      'Pengguna Independen Gratis: (opsi pribadi dan publik) [Perkuliahan|Acara|Ujian] anda telah disimpan dan dikategorikan Pribadi secara default. Hal ini berarti hanya anda yang dapat melihat isinya. Untuk mempublikasikannya anda dapat memilih salah satu opsi di bawah. Dengan mempublikasikan perkuliahan anda berarti ini akan tersedia bagi semua pengguna di platform.',
    OrganisationsDescription:
      'Pengguna Organisasi: (Daripada memilih “SELESAI” kami menyarankan untuk menggunakan “PUBLIKASIKAN” dan pindahkan ke halaman publikasi sebagaimana pengguna lainnya namun tanpa opsi publikasi.) [Perkuliahan|Acara|Ujian] anda telah disimpan dan dikategorikan Pribadi. Hal ini berarti hanya anda dan administrator Organisasi anda yang dapat melihatnya. Sebagai pengguna anda tidak dapat mempublikasikan konten anda dalam organisasi, karena untuk melakukannya anda membutuhkan hak administrator. Harap hubungi Administrator anda untuk meminta dipublikasikannya konten anda, kepada seluruh organisasi, grup tertentu atau ke pengguna tertentu.',
    OrganisationGroupsDescription:
      'Admin Organisasi: (Untuk konten yang dibuat di d alam organisasi: Pribadi, Publik, Organisasi, Grup, Pengguna tertentu): [Perkuliahan|Acara|Ujian] ini telah disimpan dan dikategorikan Pribadi secara default. Hal ini berarti hanya anda (dan pembuat konten) yang dapat melihat konten ini. Untuk mempublikasikan konten ini anda dapat memilih salah satu opsi di bawah. Dengan mempublikasikan perkuliahan anda berarti ini akan tersedia bagi semua pengguna di platform – termasuk bagi pengguna di luar organisasi anda. Mempublikasikannya bagi organisasi berarti pengguna dalam organisasi dapat melihatnya. Anda juga dapat mempublikasikannya bagi 1 grup atau lebih yang berarti hanya anggota grup tersebut yang dapat melihatnya. Terakhir anda dapat memilih untuk mempublikasikannya kepada pengguna tertentu di dalam dan di luar organisasi anda dengan menggunakan alamat email akun Sharelooknya.',
    SpecificUsersDescription:
      'Pengguna Independen Berbayar: (pribadi, publik dan pengguna tertentu) [Perkuliahan|Acara|Ujian] anda telah disimpan dan dikategorikan Pribadi secara default. Hal ini berarti hanya anda yang dapat melihat isinya. Untuk mempublikasikannya anda dapat memilih salah satu opsi di bawah. Dengan mempublikasikan perkuliahan anda berarti ini akan tersedia bagi semua pengguna di platform. Opsi pengguna tertentu akan memperbolehkan anda membagikan perkuliahan anda hanya kepada pengguna tertentu menggunakan alamat email yang didaftarkan dalam akun Sharelooknya.'
  },

  quiz: {
    quiz_empty: 'Anda belum membuat kuis',
    questions_empty: 'Anda belum membuat pertanyaan'
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'India',
    asia_pacific_japan: 'Jepang',
    asia_pacific_s_korea: 'Korea Selatan',
    asia_pacific_singapore: 'Singapura',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Belgia',
    eu_germany: 'Jerman',
    eu_ireland: 'Irlandia',
    south_america_brazil: 'Brasil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'Carolina Selatan',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },

  reports: {
    title: 'Laporan',
    workshop_report: 'Laporan Ruang Kerja',
    user_report: 'Laporan Pengguna',
    organization_workshop: 'Ruang Kerja Organisasi',
    course: 'Perkuliahan',
    live_event: 'Acara Langsung',
    workShop_graph: 'Grafik Ruang Kerja',
    organization_account: 'Akun Organisasi',
    all: 'Semua',
    name: 'Nama',
    id_number: 'Nomer ID',
    email: 'Email',
    search_user_report: 'Cari Laporan Pengguna',
    participant: 'Peserta',
    participants: 'Peserta',
    host: 'Pembawa Acara',
    username: 'Nama Pengguna',
    event: 'Acara',
    quiz: 'Kuis',
    assessment: 'Ujian',
    time: 'Waktu',
    no_recent_activity: 'Tidak Ada Aktivitas terbaru',
    workshops: 'Ruang Kerja',
    courses: 'Perkuliahan',
    live_events: 'Acara Langsung',
    live_assessments: 'Ujian Langsung',
    quizzes: 'Kuis',
    overview: 'Ringkasan',
    by: 'Oleh',
    views: 'Dilihat',
    status: 'Status',
    poll: 'Poling',
    comment: 'Komentar',
    comments: 'Komentar',
    no_comments: 'Tidak ada komentar',
    no_polls: 'Tidak ada Poling',
    live_date: 'Tanggal disiarkan langsung',
    score: 'Nilai',
    question: 'Pertanyaan',
    submit: 'Kirim',
    recent_activity: 'Aktivitas Terbaru',
    ago: 'Sebelumnya',
    no_data_found: 'Data tidak ditemukan',
    start_end_live: 'Mulai / Akhiri Siaran Langsung',
    join_leave_date: 'Bergabung / Tinggalkan',
    watched_time: 'Durasi melihat',
    complete: 'Selesai',
    in_complete: 'Belum Selesai',
    today: 'Hari ini',
    seven_days: '7 Hari',
    last_month: 'Sebulan terakhir',
    one_year: '1 Tahun',
    all_time: 'Sepanjang waktu',
    report: 'Laporan',
    from_date: 'Mulai tanggal',
    to_date: 'Hingga tanggal',
    all_workshop: 'Semua Ruang Kerja',
    all_participants: 'Semua Peserta',
    live_assessment: 'Ujian Langsung',
    users: 'Pengguna',
    download: 'Unduh',
    recent: 'Terkini',
    WorkShop: 'Ruang Kerja',
    Activity: 'Aktivitas',
    created_date: 'Tanggal dibuat',
    lessons: 'Pelajaran',
    lesson: 'Pelajaran',
    completed: 'Telah selesai',
    report_download: 'Unduh Laporan',
    this_month: 'Bulan ini',
    search_course: 'Cari Perkuliahan',
    participants_graph: 'Grafik Peserta',
    viewed: 'Telah ditonton',
    enrolled: 'Mengikuti',
    description: 'Deskripsi',
    topic: 'Topik',
    analytic: 'Analitik',
    quiz_list: 'Daftar Kuis',
    select_one: 'Pilih Satu',
    group_status: 'Status Grup',
    duration_min: 'Durasi (menit)',
    submit_poll: 'Kirim Poling',
    download_events: 'Unduh Acara',
    search_event: 'Cari Acara',
    duration: 'Durasi',
    total_participants: 'Total Peserta',
    message: 'Pesan',
    avg_message: 'Rata-rata Pesan',
    per_message: 'PERSENTASE PESAN / ACARA'
  },

  signup: {
    success_step1:
      ' Kami telah mengirimkan email berisi kode konfirmasi ke alamat email yang anda sediakan, harap salin kode tersebut ke dalam bidang di bawah untuk mengkonfirmasi pendaftaran anda.',
    success_step2: 'Terima kasih. Anda berhasil mendaftar.',
    privacy: `Saya menyetujui <1> syarat & ketentuan</1> and <3> kebijakan privasi</3> Sharelook `
  },

  stream: {
    emotion_impressive: 'Mengesankan',
    emotion_unimpressive: 'Tidak Mengesankan',
    message_not_started: 'Segera Hadir',
    message_running: 'Langsung',
    message_processing:
      'Saat ini kami sedang memproses rekaman langsung untuk ditampilkan. Harap periksa kembali nanti untuk melihat video dan menambahkan penilaian serta umpan balik.'
  },

  tabs: {
    audience: 'Pemirsa',
    course: 'Ringkasan Perkuliahan',
    details: 'Detail Acara Langsung',
    description: 'Deskripsi',
    host: 'Pembawa Acara',
    lesson: 'Ringkasan Pelajaran',
    lessons: 'Pelajaran',
    overview: 'Ringkasan',
    page: 'Pembuat Halaman',
    publish: 'Publikasi',
    settings: 'Pengaturan Publikasi',
    total_views: 'Total dilihat',
    live_participates: 'Peserta yang sedang mengikuti',
    live_chats: 'Percakapan Berlangsung',
    live_quiz: 'Poling Berlangsung',
    trainer_rating: 'Penilaian Pelatih',
    trainer_times: 'Jam Terbang Pelatih',
    courses_quizzes: 'Kuis Perkuliahan',
    user_list: 'Daftar Pengguna',
    discussion: 'Diskusi',
    notes: 'Catatanku'
  },

  topics: {
    SALES_TRAINING: 'Pelatihan Sales',
    NEGOTIATION_TRAINING: 'Pelatihan Negosiasi',
    CROSS_CULTURAL_AWARENESS: 'Kesadaran Lintas Kultur',
    NETWORKING_SKILLS: 'Keterampilan Networking',
    SOFTWARE_ARCHITECTURE: 'Arsitektur Perangkat Lunak',
    PROJECT_MANAGEMENT: 'Manajemen Proyek',
    DIGITAL_TRANSFORMATION: 'Transformasi Digital',
    IT_CONSULTING: 'Konsultasi IT',
    MANAGEMENT_CONSULTING: 'Konsultasi Manajemen',
    HR_CONSULTING: 'Konsultasi Sumber Daya Manusia (SDM)',
    INTERNET_OF_THINGS: 'Internet of Things (IoT)',
    CYBERSECURITY: 'Keamanan Siber',
    PRIVACY_AND_GDRP: 'Privasi dan GDPR'
  },

  training: {
    title: 'Pelatihan',
    title_assessment: 'Ujian',
    subtitle: 'Acara Langsung dan Perkuliahan',
    enrolled_title: ' Acara Langsung dan Perkuliahan yang diikuti',
    enrolled_subtitle:
      ' Acara Langsung dan Perkuliahan yang anda ikut di dalamnya',
    enrolled_message:
      'Saat ini anda tidak sedang mengikuti Perkuliahan dan Acara apapun.',
    past_live_event_title: 'Acara Langsung Sebelumnya',
    past_live_event_subTitle: 'Acara Langsung yang telah berakhir',
    past_live_event: 'Saat ini acara langsung sebelumnya tidak ada.',
    recomended_title: 'Acara Langsung dan Perkuliahan yang disarankan',
    now_live_event_title: 'Berlangsung saat ini',
    now_live_event_subTitle:
      'Acara yang sedang siaran langsung atau akan disiarkan dalam waktu dekat',
    now_live_event: 'Saat ini Acara Langsung tidak ada.',
    webinar_event_title: 'Saluran Webinar',
    webinar_event_subTitle: 'Webinar yang telah berakhir',
    webinar_event: 'Saat ini Webinar tidak ada.',
    p2p_event_title: 'Sesi Pelatihan',
    p2p_event_subTitle: 'Sesi Pelatihan yang telah berakhir',
    p2p_event: 'Saat ini sesi pelatihan tidak ada.',

    now_live_assessment_title: 'Sedang berlangsung',
    now_live_assessment_subTitle:
      'Ujian yang sedang siaran langsung atau akan disiarkan dalam waktu dekat ',
    now_live_assessment_message: ' Saat ini Ujian Langsung tidak ada.',

    upcoming_assessment_title: 'Ujian Langsung berikutnya',
    upcoming_assessment_subtitle: ' Ujian Langsung berikutnya ',
    upcoming_assessment_message:
      'Saat ini Ujian Langsung berikutnya tidak ada.',

    past_live_assessment_title: 'Ujian Langsung sebelumnya',
    past_live_assessment_subTitle: 'Ujian Langsung yang telah berakhir',
    past_live_assessment_message:
      ' Saat ini ujian langsung sebelumnya tidak ada.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Kami telah mengkurasi perkuliahan dan acara langsung berdasarkan <0><0/></0> anda',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Cari Latihan',
    search_assessment: 'Cari Ujian',
    recomended_message:
      'Saat ini Acara Langsung dan Perkuliahan yang disarankan tidak ada.'
  },

  warnings: {
    delete: 'Apakah anda yakin?'
  },

  workshop: {
    title: 'Ruang Kerjaku',
    subtitle: 'Buatlah sendiri perkuliahan atau bawakan siaran langsungmu',
    new_course: 'Buat Perkuliahan Baru',
    new_event: 'Buat acara langsung baru',
    new_assessment: 'Buat ujian langsung baru',
    courses_title: 'Acara Langsung dan Perkuliahan yang telah dibuat',
    courses_subtitle:
      'Edit & Publikasikan rencana acara langsung dan Perkuliahan yang telah dibuat',
    tags_course: 'Perkuliahan',
    tags_live: 'Acara Langsung',
    tags_assessment: 'Ujian Langsung'
  },

  help_center: {
    sidebar: {
      title: 'Bantuan apa yang anda butuhkan?',
      back_to: 'Dasbor'
    },
    menu: {
      help_center: 'Pusat Bantuan',
      whats_new: 'Yang baru',
      feedback: 'Umpan Balik',
      feedback_title: 'Beikan umpan balik untuk sharelook',
      terms_and_conditions: 'Syarat & Ketentuan',
      privacy_policy: 'Kebijakan Privasi',
      contact_us: 'Hubungi kami'
    },
    get_started: {
      title: 'Mulai menggunakan share look',
      description: {
        main:
          'KAMI TELAH MENGINTEGRASIKAN VIDEO LIVE KEDALAM APLIKASI PEMBUAT PERKULIAHAN YANG MUDAH DIGUNAKAN',
        tagline:
          'Bersama ShareLook, sistem siaran langsung yang telah dipatenkan, anda dapat membangun kebersamaan, otomatisasi pembelajaran dan berbagi pengetahuan secara maksimal.'
      }
    },
    whats_new: {
      title: 'Mulai menggunakan share look',
      description: {
        main: `Tahukah anda, pola pembelajaran dengan cara bercerita dapat dibuat dalam waktu singkat dengan biaya murah? Anda harus menggabungkan aplikasi pembuat perkuliahan ShareLook dengan bakat yang tepat. Anda dapat bertanya kepada kami “Bagaimana Caranya”`,
        tagline: ''
      }
    },
    create_workshop: 'Bagaimana cara membuat sebuah Ruang Kerja',
    create_course: 'Bagaimana cara membuat sebuah Perkuliahan',
    create_user: 'Bagaimana cara membuat Pengguna',
    create_group: 'Bagaimana cara membuat sebuah Grup',
    create_webinar: 'Bagaimana cara membuat Webinar',
    create_live_event: 'Bagaimana cara membuat Acara Langsung',
    create_live_assessment: 'Bagaimana cara membuat Ujian Langsung',
    create_live_on_mobile: 'Siaran Langsung dari Gawai',
    personalize_profile: 'Pengaturan Profil',
    manage_group: 'Mengelola Grup',
    report: 'Laporan',
    add_annotations: 'Bagaimana cara menambahkan Keterangan /Popups',
    add_audio: 'Bagaimana cara menambahkan Audio',
    add_header_and_footer: 'Menambahkan Header & Footer',
    add_image: 'Bagaimana cara menambahkan Gambar',
    add_quiz_content: 'Bagaimana cara menambahkan Konten Kuis',
    add_text_content: 'Bagaimana cara menambahkan Konten Teks',
    add_user: 'Bagaimana cara menambahkan pengguna',
    add_video: 'Bagaimana cara menambahkan Video',
    clone_course: 'Bagaimana cara menggandakan Perkuliahan',
    find_live_broadcast: 'Bagaimana cara mencari Siaran Langsung',
    contact_us: {
      title: 'Hubungi kami',
      subject_placeholder: 'Masukkan Subyek *',
      content_placeholder: 'Masukkan Pesan*',
      subject_required: '*Subyek harus diisi',
      content_required: '*Pesan harus diisi',
      submit: 'Kirim',
      cancel: 'Batal',
      sent: 'Terkirim'
    },
    feedback: {
      title: 'Kirim umpan balik ke sharelook',
      attach_title: 'Lampirkan sebuah file',
      choose: 'Pilih file',
      detail: 'File akan dibagikan dengan tim support',
      content_placeholder: 'Masukkan pesan*',
      content_required: '*Pesan harus diisi',
      submit: 'Kirim',
      cancel: 'Batal',
      sent: 'Terkirim'
    }
  },
  discussion: {
    join_discussion: 'Bergabung dalam diskusi'
  },
  notes: {
    title: 'Catatanku',
    add_note: 'Tambah catatan baru'
  }
}
